import { ConSourceModule } from '../interfaces';

export const CONSTANTS = {
  defaultLanguage: 'english',
  defaultLanguageId: '61c1a737afc00e4c9aad3aeb',
  role: {
    clientAdmin: 1,
    admin: 5,
    manager: 2,
    partner: 3,
    sponsor: 4,
    firmAdmin: 6,
    firmUser: 7 /*firm partner*/,
    CFUser: 9 /*firm user*/,
    firmManagement: 8,
  },
  allUserRole: [1, 2, 3, 4, 6, 7, 8, 9],
  CF_PROFILE_ROLES: [6, 7, 8, 9],
  CF_PROFILE_USER_ROLES: [7, 8, 9],
  CF_PROFILE_PARTNER_AND_USER: [7, 9],
  CF_PROFILE_ADMIN_AND_MANAGER: [6, 8],
  CLIENT_USER_ROLES: [1, 2, 3, 4],
  CLIENT_USER: [2, 3, 4],
  MAX_NOTIFICATION_COUNT_IN_HEADER_LIST: 10,
  CONSOURCE_TEAM: 'Consource Team',
  currencySymbol: {
    dollar: '$',
  },
  projectStep: {
    demand: 1,
    rfp: 2,
    sourcing: 3,
    questionAndAns: 4,
    selection: 5,
    sow: 6,
    projectManagement: 7,
    performance: 8,
  },
  ProjectFastTrack: {
    sandbox: 0,
    rfp: 1,
    sow: 2,
    management: 3,
    performance: 4,
  },
  NoDataContent: {
    search: '',
    btnName: 'Add',
    isSmall: false,
    title: 'No Records',
    content: 'Sorry, there are no records to display',
    isActionNeed: false,
  },
  YoutubeUrlPattern: /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/,
  DEFAULT_USER_PROFILE_IMAGE: 'https://conpulse.s3.us-east-2.amazonaws.com/assets/default_user_image.jpeg',
  tableType: {
    user: 'User',
    firm: 'Firm',
    client: 'Client',
    action: 'Action',
    firmAction: 'Firm Action',
    project: 'Project',
    country: 'Country',
    contact: 'Contact',
    contract: 'Contract',
    partner: 'Partner',
    projectManagementChanges: 'ProjectManagementChanges',
    sowDocument: 'SowDocument',
    projectRequest: 'Demand',
    invitedProject: 'Invited Project',
    rfpProposal: 'RfpProjectProposal',
    rfpExportHistory: 'RfpExportHistory',
    rfpSowTeamMembers: 'RfpSowTeamMembers',
    rfpDemandApprover: 'RfpDemandApprover',
    rfpProposalClient: 'RfpProposalClient',
    organisationalUnit: 'OrganisationalUnit',
    projectPerformance: 'ProjectPerformance',
    strategicPriorities: 'Strategic Priorities',
    rfpProposalshortList: 'RfpProposalShortList',
    rfpProposalEvaluator: 'rfpProposalEvaluator',
    rfpProjectTeamMembers: 'RfpProjectTeamMembers',
    sowTerminologyTermTable: 'SowTerminologyTermTable',
    rfpSelectionConsultingFirm: 'RfpSelectionConsultingFirm',
    rfpInvitationConsultingFirm: 'RfpInvitationConsultingFirm',
    sowProjectManagementMilestone: 'SowProjectManagementMilestone',
    sowProjectManagementGovernance: 'SowProjectManagementGovernance',
    sowProjecTermsAndConditionCost: 'SowProjecTermsAndConditionCost',
    projectPerformanceExpectedImpact: 'ProjectPerformanceExpectedImpact',
    sowProjecTermsAndConditionMileStone: 'SowProjecTermsAndConditionMileStone',
    sowProjecTermsAndConditionDetailedFee: 'sowProjecTermsAndConditionDetailedFee',
    library: 'Library',
    meetings: 'Meeting',
    dashboardMeeting: 'DashboardMeeting',
    ndaTerminologyTermTable: 'ndaTerminologyTermTable',
    definitionTable: 'ndaTerminologyTermTable',
    legalEntities: 'LegalEntities',
    invoicingAndPayment: 'invoicingAndPayment',
    legalEntity: 'legalEntity',
    linkedFirm: 'Linked Firm',
    workspaceMeetings: 'workspaceMeetings',
    performanceDocument: 'performanceDocument',
    rfpTeamsDisabled: 'rfpTeamsDisabled',
    suggestedProviders: 'suggestedProviders',
    pmChanges: 'pmChanges',
  },
  workspaceTab: {
    file: 'file',
    meetings: 'meetings',
    task: 'task',
    links: 'links',
    chats: 'chats',
  },
  accessValue: {
    edit: ['edit', 'editAll'],
    delete: ['delete', 'deleteAll'],
    deleteOwn: ['delete'],
    view: ['view', 'viewAll'],
    create: ['create'],
    deleteAll: ['deleteAll'],
    editAll: ['editAll']
  },
  signatureTabs: {
    execution: 'execution',
    finalization: 'finalization',
    selection: 'selection',
    award: 'award',
  },
  contractType: {
    sow: 1,
    nda: 2,
    msa: 3,
  },
  proposalTableType: {
    teamScoring: 'teamMyScoring',
    myScoring: 'proposalMyScoring',
  },
  pattern: {
    email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  },
  threeMonths: '3_Months',
  sixMonths: '6_Months',
  twelveMonths: '12_Months',
  All: 'All',
  Custom: 'Custom',
  fiscalYear: 'fiscalYear',
  geographyTypes: [
    { name: 'Regions', value: 1 },
    { name: 'Countries', value: 2 },
    { name: 'Other', value: 3 },
  ],
  filterValue: [
    {
      id: 1,
      name: 'Results',
    },
    {
      id: 2,
      name: 'Process',
    },
    // {
    //   id: 5,
    //   name: 'Others',
    // },
  ],
  displayRoles: [
    {
      id: 2,
      name: 'Manager',
    },
    {
      id: 3,
      name: 'Partner',
    },
    /*{
            id: 4,
            name: 'Manager and Partner',
        },*/
  ],
  displayConsultingFirmRole: [
    {
      id: 9,
      name: 'Provider User',
    },
    {
      id: 7,
      name: 'Provider Partner',
    },
    {
      id: 8,
      name: 'Provider Management',
    },
  ],
  displayConsultingFirmChangeRole: [
    {
      id: 6,
      name: 'Provider Admin',
    },
    {
      id: 9,
      name: 'Provider User',
    },
    {
      id: 7,
      name: 'Provider Partner',
    },
    {
      id: 8,
      name: 'Provider Management',
    },
  ],
  displayClientUserRoles: [
    {
      id: 2,
      name: 'Procurement manager',
    },
    {
      id: 3,
      name: 'Project manager',
    },
    {
      id: 4,
      name: 'Project sponsor',
    },
  ],
  displayClientRoles: [
    {
      id: 1,
      name: 'Client Admin',
    },
    {
      id: 2,
      name: 'Procurement manager',
    },
    {
      id: 3,
      name: 'Project manager',
    },
    {
      id: 4,
      name: 'Project sponsor',
    },
  ],
  rfpProjectTeamRoles: [
    {
      id: 1,
      name: 'Leader',
    },
    {
      id: 2,
      name: 'Member',
    },
  ],
  projectSowTeamRoles: [
    {
      id: 1,
      name: 'Project Lead',
    },
    {
      id: 2,
      name: 'Project Team',
    },
    {
      id: 3,
      name: 'Legal Team',
    },
    {
      id: 4,
      name: 'Partner Incharge',
    },
  ],
  projectTeamRoles: [
    {
      id: 1,
      name: 'Project Lead',
    },
    {
      id: 2,
      name: 'Project Team',
    },
    {
      id: 3,
      name: 'Legal Team',
    },
    {
      id: 4,
      name: 'Partner Incharge',
    },
    {
      id: 5,
      name: 'Project Contributor',
    },
  ],
  clientPriority: [
    {
      id: 1,
      name: 'Commercial',
    },
    {
      id: 2,
      name: 'Delivery',
    },
    {
      id: 3,
      name: 'Talent Expertise',
    },
    {
      id: 4,
      name: 'Behavior',
    },
    {
      id: 5,
      name: 'Impact',
    },
  ],
  clientPriorityForSpendAnalysis: [
    {
      id: 1,
      name: 'Commercial',
    },
    {
      id: 2,
      name: 'Delivery',
    },
    {
      id: 3,
      name: 'Talent Expertise',
    },
    {
      id: 4,
      name: 'Behavior',
    },
    {
      id: 5,
      name: 'Impact',
    },
    {
      id: 6,
      name: 'Global',
    },
  ],
  projectType: [
    {
      id: 1,
      name: 'Long term',
    },
    {
      id: 2,
      name: 'Short term',
    },
    {
      id: 3,
      name: 'Retainer',
    },
    {
      id: 4,
      name: 'Workshop',
    },
  ],
  isProjectPaid: [
    {
      id: 1,
      name: 'Realized',
    },
    {
      id: 2,
      name: 'Engaged',
    },
  ],
  projectRequestStatus: [
    {
      id: 0,
      name: 'Requested',
    },
    {
      id: 1,
      name: 'Approved',
    },
    {
      id: 2,
      name: 'Rejected',
    },
    {
      id: 3,
      name: 'Drafted',
    },
  ],
  projectPerformanceType: [
    {
      id: 1,
      name: 'Projects',
    },
    {
      id: 2,
      name: 'Capabilities',
    },
    {
      id: 3,
      name: 'Industries',
    },
  ],
  statusFilterOptions: [
    {
      _id: 1,
      name: 'Active',
    },
    {
      _id: 0,
      name: 'Pending',
    },
  ],
  userStatusFilterOptions: [
    {
      _id: 1,
      name: 'Active',
    },
    {
      _id: 2,
      name: 'Pending',
    },
  ],
  statusFilterOptionsForFirm: [
    {
      _id: 1,
      name: 'Active',
    },
    {
      _id: 2,
      name: 'Pending',
    },
    {
      _id: 3,
      name: 'Disabled',
    },
  ],
  roleFilterOptions: [
    {
      _id: 2,
      name: 'Manager',
    },
    {
      _id: 3,
      name: 'Partner',
    },
    /*{
            _id: 4,
            name: 'Manager and Partner',
        },*/
  ],
  clientRoleFilterOptions: [
    {
      _id: 2,
      name: 'Procurement Manager',
    },
    {
      _id: 3,
      name: 'Project Manger',
    },
    {
      _id: 4,
      name: 'Project sponsor',
    },
  ],
  contactStatus: [
    {
      _id: 3,
      name: 'All',
    },
    {
      _id: 1,
      name: 'Pending',
    },
    {
      _id: 2,
      name: 'Completed',
    },
  ],
  admin: 'Admin',
  user: 'User',
  dateFilterOption: [
    {
      id: 1,
      name: 'Today',
    },
    {
      id: 2,
      name: 'Yesterday',
    },
    {
      id: 3,
      name: 'Last 7 days',
    },
    {
      id: 4,
      name: 'Last 30 days',
    },
    {
      id: 5,
      name: 'Last 90 days',
    },
    {
      id: 6,
      name: 'Custom Date Range',
    },
  ],
  actionDateFilterOption: [
    {
      id: 7,
      name: 'Remote',
    },
    {
      id: 8,
      name: 'Upcoming',
    },
    {
      id: 9,
      name: 'Overdue',
    },
    {
      id: 6,
      name: 'Custom Date Range',
    },
  ],
  flagUrl: 'https://devapp.consource.io/assets/images/flags/',
  knowledgeBaseConsourceUrl: 'https://support.consource.io/portal/en/signin',
  surveyId: '5cac4a07394ad1c096d0cc5b',
  displayMonth: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  variabilityGraphXAxis: [
    {
      id: 1,
      name: 'Capability',
    },
    {
      id: 2,
      name: 'Purpose',
    },
  ],
  variabilityGraphYAxis: [
    {
      id: 1,
      name: 'Score',
    },
    {
      id: 2,
      name: 'Price',
    },
  ],
  profileGraphXAxis: [
    {
      id: 1,
      name: 'Projects',
    },
    {
      id: 2,
      name: 'Providers',
    },
  ],
  auth0Config: {
    domain: 'consourse-dev.us.auth0.com',
    clientId: 'ArVnI0yjXNbluqoMMSKiUGNevci6Ekyc',
    audience: 'https://consourse-dev.us.auth0.com/api/v2/',
  },
  totalDaysFreeTrail: 30,
  zohoCustomerPortalUrl: 'https://subscriptions.zoho.com/portal/consultingquest',
  revenueFilterType: [
    {
      id: 1,
      name: 'Projects',
    },
    {
      id: 2,
      name: 'Clients',
    },
    {
      id: 3,
      name: 'Capabilities',
    },
    {
      id: 4,
      name: 'Industries',
    },
  ],
  consourceRevenueFilterType: [
    {
      id: 1,
      name: 'Projects',
    },
    {
      id: 5,
      name: 'Providers',
    },
    {
      id: 3,
      name: 'Capabilities',
    },
    {
      id: 4,
      name: 'Industries',
    },
  ],
  benchmarkFilterType: [
    {
      id: 1,
      name: 'Partners',
    },
    {
      id: 2,
      name: 'Capabilities',
    },
    {
      id: 3,
      name: 'Industries',
    },
    {
      id: 4,
      name: 'Organisation Tags',
    },
  ],
  budgetOptions: [
    {
      key: 'no-condition',
      value: 'no-condition',
    },
    {
      key: '>',
      value: 'greater than',
    },
    {
      key: '<',
      value: 'lesser than',
    },
    {
      key: '>=',
      value: 'greater than or equal to',
    },
    {
      key: '<=',
      value: 'lesser than or equal to',
    },
    {
      key: 'between',
      value: 'between',
    },
  ],
  projectRequestTypes: [
    {
      key: 0,
      value: 'All',
    },
    {
      key: 1,
      value: 'Requests Sent',
    },
    {
      key: 2,
      value: 'Requests Received',
    },
  ],
  surveyStatus: {
    NotSend: 1,
    SentButNotCompleted: 2,
    Completed: 3,
  },
  projectRequestNotMatched: 'The Demand is not matched on any approval criteria',
  actionsNature: [
    {
      key: '0',
      value: 'Administrative',
    },
    {
      key: '1',
      value: 'Debriefing',
    },
    {
      key: '2',
      value: 'Improvement',
    },
    {
      key: '3',
      value: 'Opportunity',
    },
  ],
  meetingtypes: [
    {
      key: 0,
      value: 'All',
    },
    {
      key: 1,
      value: 'Project Management',
    },
    {
      key: 2,
      value: 'Provider',
    },
  ],
  taskActionNature: [
    {
      key: '4',
      value: 'Project',
    },
  ],
  actioinStatus: [
    {
      key: 0,
      value: 'Open',
    },
    {
      key: 1,
      value: 'Closed',
    },
  ],
  archiveStatus: [
    {
      key: 'Archived',
      value: 1,
    },
    {
      key: 'Non Archived',
      value: 0,
    },
  ],
  tierTypes: {
    project: 1,
    ConsultingFirm: 2,
  },
  tierCategory: {
    tier: 'tier',
    segment: 'segment',
  },
  rfpDemandDocument: {
    size: 10 * 1024 * 1024,
    allowedFiles: '.doc,.docx,.pptx,.xlxs,.pdf,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
  },
  rfpQuestionVisibility: [
    {
      key: -1,
      value: 'All',
    },
    {
      key: 1,
      value: 'Public',
    },
    {
      key: 2,
      value: 'Private',
    },
  ],
  filePath: {
    rfp: '',
    sowDocument: 'project/sow',
    proposalAndSelection: 'project/proposalAndSelection',
    milestone: 'project/projectManagementDocument',
    invoicing: 'projectManagementInvoicing',
    ndaDocument: 'contracts/nda',
    msaDocument: 'contracts/msa',
    onBoardingTemplate: 'on-boarding/template',
    chat: 'workspace/chat',
  },
  proposaAndSelectionType: [
    {
      key: 1,
      value: 'Proposal',
    },
    {
      key: 2,
      value: 'Side Document',
    },
  ],
  proposaAndSelectionStep: [
    {
      key: 1,
      value: 'Initial',
    },
    {
      key: 2,
      value: 'Pitch',
    },
    {
      key: 3,
      value: 'Revisions',
    },
  ],
  rfpProposalText: 'Reception of the Initial Proposals',
  rfpPitchByConsultants: 'Pitch by Providers',
  rfpFinalSelection: 'Final Selection',
  clientURL: {
    adminActionUrl: '/dashboard/tasks/all-tasks',
    actionUrl: '/dashboard/tasks/my-tasks',
  },
  superAdminUrl: {
    actionUrl: '/dashboard/my-tasks',
  },
  firmAccountUrl: {
    accountUrl: '/invitation-dashboard/account-billing/account',
  },
  legalEntityAccount: {
    accountUrl: 'invitation-dashboard/legal-entity/edit',
  },
  firmURL: {
    actionURL: '/invitation-dashboard/my-tasks',
  },
  SowRefDocument: [
    {
      key: 1,
      value: 'RFP',
    },
    {
      key: 2,
      value: 'Proposal',
    },
    {
      key: 3,
      value: 'Others',
    },
    {
      key: 4,
      value: 'NDA',
    },
    {
      key: 5,
      value: 'MSA',
    },
    {
      key: 6,
      value: 'SOW',
    },
  ],
  fastTrackList: [
    {
      key: 1,
      value: 'RFP',
    },
    {
      key: 2,
      value: 'SoW',
    },
    {
      key: 3,
      value: 'Project Management',
    },
    {
      key: 4,
      value: 'Performance',
    },
  ],
  DOCUMENT_TYPE: {
    LOCAL: 1,
    DRIVE: 2,
  },
  SPECIFIC_INFO_DOC_TYPE: {
    COMPLIANCE: 'complianceData',
    CERTIFICATION: 'certificationData',
    LEGAL: 'legalFiscalData',
    ONBOARDING: 'onboardingData',
  },
  FIRM_SPECIFIC_INFO_DOC_FILE_LIMIT: 3,
  CONTRACTSTATUS: {
    INPROGRESS: 'in-progress',
    EXECUTED: 'executed',
  },
  CONTRACT_TYPE_ID: {
    1: 'sowId',
    2: 'ndaId',
    3: 'msaId',
  },
  CONTRACT_TYPE_KEYS: {
    1: 'sowDetails',
    2: 'ndaDetails',
    3: 'msaDetails',
  },
  CONTRACT_DOCUMENT_PATH: {
    2: 'contracts/nda',
    3: 'contracts/msa',
  },
  GENERIC_NO_DATA_TABLE_ERROR_MESSAGE: {
    title: 'No Records',
    subtitle: `SORRY! There Isn't Any Records To Display!`,
  },
  CURRENCY_TYPES_IN_PROJECTS: {
    INVOICE_CURRENCY: 'Invoice Currency',
    PROJECT_CURRENCY: 'Project Currency',
    COMPANY_CURRENCY: 'Company Currency',
  },
  GENERIC_ERROR_RESPONSE: 'Something went wrong',
};

export const DefaultContentStyle = { fontStyle: '', fontSize: '', fontFamily: '', color: '' };

export const ASSETS = {
  NO_DATA_FOUND_IMAGE_PATH: 'assets/not_found.png',
  COMING_SOON_IMAGE_PATH: 'assets/coming_soon.png',
  CARD_IMAGE_PATH: 'assets/card-image.png',
  AWARDS_IMAGE_PATH: 'assets/awards.png',
};

export const rfpDocumentAllowedFileTypes = ['.pdf', '.docx', '.doc', 'xlsx', '.xls', '.ppt', '.pptx']; // Common document file formats
export const rfpDocumentAllowedOverallSize = 50 * 1024 * 1024; // 50 MB
export const rfpDocumentAllowedFileCount = 2; // Max Files Count

export const rfpPdfLogoAllowedFileTypes = ['.jpeg', '.jpg', '.png']; // Image file formats
export const rfpPdfLogoAllowedSize = 50 * 1024; // 50 KB

export const defaultCompanyProfilePhoto = 'assets/images/company-profile-photo.png';

export const RfpQuillConfig = {
  toolbar: {
    container: [
      ['bold', 'italic', 'underline', { color: [] }],
      [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
      [{ list: 'ordered' }, { list: 'bullet' }, 'link'],
      ['image'],
    ],
  },
  imageResize: true,
};

export const RfpSettingsQuillConfig = {
  toolbar: {
    container: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', { color: [] }],
      [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
      ['image'],
    ],
  },
  imageResize: true,
  textChanges: true,
};

export const RfpSettingsQuillConfigWithoutToolbar = {
  toolbar: false,
  imageResize: true,
};

export enum RfpTableTypes {
  'Demand',
  'RFP',
  'Project',
  'SOW',
}

export const LayoutSections = [
  {
    sectionName: '',
    sectionKey: 'brandingPreferences',
    fields: [
      {
        fieldName: 'Cover Page Content',
        fieldKey: 'coverPageContent',
      },
      {
        fieldName: 'Header Content',
        fieldKey: 'headerContent',
      },
      {
        fieldName: 'Footer Content',
        fieldKey: 'footerContent',
      },
    ],
  },
];

export const MsaDefaultSections = [
  {
    sectionName: 'Preliminary Info',
    sectionKey: 'preliminaryInfo',
    fields: [
      {
        fieldName: 'Introduction & Parties',
        fieldKey: 'introduction',
      },
      {
        fieldName: 'Terminology & Acronyms',
        fieldKey: 'terminologyAndAcronyms',
      },
    ],
  },
  {
    sectionName: 'Term & Termination',
    sectionKey: 'termAndTermination',
    fields: [
      {
        fieldName: 'Termination',
        fieldKey: 'termination',
      },
    ],
  },
  {
    sectionName: 'Services',
    sectionKey: 'services',
    type: 'dynamic',
    fields: [],
  },
  {
    sectionName: 'Standards of Performance',
    sectionKey: 'standardsOfPerformance',
    type: 'dynamic',
    fields: [],
  },
  {
    sectionName: 'General Provisions',
    sectionKey: 'generalProvisions',
    type: 'dynamic',
    fields: [],
  },
  {
    sectionName: 'Other Provisions',
    sectionKey: 'otherProvisions',
    type: 'dynamic',
    fields: [],
  },
  {
    sectionName: 'Appendix',
    sectionKey: 'appendix',
    type: 'dynamic',
    fields: [],
  },
];

export const NdaDefaultSections = [
  {
    sectionName: 'Preliminary Info',
    sectionKey: 'preliminaryInfo',
    fields: [
      {
        fieldName: 'Introduction & Parties',
        fieldKey: 'intro',
      },
      {
        fieldName: 'Terminology',
        fieldKey: 'terminology',
      },
    ],
  },
  {
    sectionName: 'Confidential information',
    sectionKey: 'confidentialInformation',
    fields: [
      {
        fieldName: 'Definition of Confidential Information',
        fieldKey: 'definition',
      },
      {
        fieldName: 'Exclusions from Confidential Information',
        fieldKey: 'exclusions',
      },
    ],
  },
  {
    sectionName: 'Obligations',
    sectionKey: 'obligations',
    fields: [
      {
        fieldName: 'Obligations of disclosing party',
        fieldKey: 'disclosingParty',
      },
      {
        fieldName: 'Obligations of receiving party',
        fieldKey: 'receivingParty',
      },
    ],
  },
  {
    sectionName: 'General Provisions',
    sectionKey: 'generalProvisions',
    type: 'dynamic',
    fields: [],
  },
  {
    sectionName: 'Other Provisions',
    sectionKey: 'otherProvisions',
    type: 'dynamic',
    fields: [],
  },
];

export const RFPDefaultSections = [
  {
    sectionName: 'Overview & Background',
    sectionKey: 'background',
    fields: [
      {
        fieldName: 'Project Overview',
        fieldKey: 'projectOverview',
      },
      {
        fieldName: 'Company Overview',
        fieldKey: 'companyOverview',
      },
      {
        fieldName: 'Client Overview',
        fieldKey: 'level2Overview',
      },
      {
        fieldName: 'Strategic Background',
        fieldKey: 'strategicAmbition',
      },
    ],
  },
  {
    sectionName: 'Context',
    sectionKey: 'context',
    fields: [
      {
        fieldName: 'Rationale',
        fieldKey: 'rationale',
      },
      {
        fieldName: 'Key questions',
        fieldKey: 'keyQuestions',
      },
      {
        fieldName: 'Expected benefits',
        fieldKey: 'expectedBenefits',
      },
      {
        fieldName: 'What has been done',
        fieldKey: 'whatHasBeenDone',
      },
    ],
  },
  {
    sectionName: 'Scope & Deliverables',
    sectionKey: 'scopeAndDeliverables',
    fields: [
      {
        fieldName: 'Objective(s)',
        fieldKey: 'objectives',
      },
      {
        fieldName: 'Scope',
        fieldKey: 'scope',
      },
      {
        fieldName: 'Expected Deliverables',
        fieldKey: 'expectedDeliverables',
      },
      {
        fieldName: 'Support required',
        fieldKey: 'supportRequired',
      },
    ],
  },
  {
    sectionName: 'Other Requirements',
    sectionKey: 'otherRequirements',
    fields: [
      {
        fieldName: 'Language',
        fieldKey: 'language',
      },
      {
        fieldName: 'Team Set-up',
        fieldKey: 'teamSetup',
      },
      {
        fieldName: 'Location',
        fieldKey: 'location',
      },
      {
        fieldName: 'Other information',
        fieldKey: 'other',
      },
    ],
  },
  {
    sectionName: 'Proposal Content',
    sectionKey: 'proposalContent',
    fields: [
      {
        fieldName: 'Expected Proposal Content',
        fieldKey: 'expectedProposalContent',
      },
      {
        fieldName: 'References & Expertise',
        fieldKey: 'referenceAndExpertise',
      },
      {
        fieldName: 'Fees & Workload',
        fieldKey: 'feesAndWorkload',
      },
    ],
  },
  {
    sectionName: 'RFP Process',
    sectionKey: 'rfpProcess',
    fields: [
      {
        fieldName: 'Eligibility & Qualifications',
        fieldKey: 'eligibilityAndQualifications',
      },
      {
        fieldName: 'Q&A',
        fieldKey: 'questionsAndAnswers',
      },
      {
        fieldName: 'Other Questions',
        fieldKey: 'otherQuestions',
      },
    ],
  },
];

export const SoWDefaultSections = [
  {
    sectionName: 'Preliminary Info',
    sectionKey: 'preliminaryInfo',
    fields: [
      {
        fieldName: 'Introduction & Parties',
        fieldKey: 'intro',
      },
      {
        fieldName: 'Definitions',
        fieldKey: 'terminology',
      },
    ],
  },
  {
    sectionName: 'Project Description',
    sectionKey: 'projectDescription',
    fields: [
      {
        fieldName: 'Project Name',
        fieldKey: 'projectName',
      },
      {
        fieldName: 'Project Context',
        fieldKey: 'projectContext',
      },
      {
        fieldName: 'Project Objective(s)',
        fieldKey: 'projectObjective',
      },
      {
        fieldName: 'Project Scope',
        fieldKey: 'projectScope',
      },
      {
        fieldName: 'Expected Services Context',
        fieldKey: 'servicesContext',
      },
      {
        fieldName: 'Expected Deliverables',
        fieldKey: 'expectedDeliverables',
      },
    ],
  },
  {
    sectionName: 'Project Management',
    sectionKey: 'projectManagement',
    fields: [
      {
        fieldName: 'Methodology & Timeline',
        fieldKey: 'methodology',
      },
      {
        fieldName: 'Project Milestones & Deliverables',
        fieldKey: 'table',
      },
      {
        fieldName: 'Acceptance Criteria',
        fieldKey: 'acceptanceCriteria',
      },
      {
        fieldName: 'Project Organization',
        fieldKey: 'organization',
      },
      {
        fieldName: 'Staffing',
        fieldKey: 'staffing',
      },
      {
        fieldName: 'Language',
        fieldKey: 'language',
      },
      {
        fieldName: 'Work Location',
        fieldKey: 'workLocation',
      },
      {
        fieldName: 'Status Reports',
        fieldKey: 'statusReports',
      },
      {
        fieldName: 'Assumptions',
        fieldKey: 'assumptions',
      },
    ],
  },
  {
    sectionName: 'Terms & Conditions',
    sectionKey: 'termsAndConditions',
    fields: [
      {
        fieldName: 'Maximum Project Budget',
        fieldKey: 'table',
      },
      {
        fieldName: 'Detailed Fees',
        fieldKey: 'table',
      },
      {
        fieldName: 'Invoicing Milestones',
        fieldKey: 'table',
      },
      {
        fieldName: 'Invoicing Milestones',
        fieldKey: 'table',
      },
      {
        fieldName: 'Payment Terms',
        fieldKey: 'paymentTerms',
      },
      {
        fieldName: 'PO Number',
        fieldKey: 'poNumber',
      },
      {
        fieldName: 'Invoicing Contact',
        fieldKey: 'invoicingContact',
      },
      {
        fieldName: 'Contract Administration',
        fieldKey: 'contractAdministration',
      },
    ],
  },
  {
    sectionName: 'General Provisions',
    sectionKey: 'generalProvisions',
    type: 'dynamic',
    fields: [],
  },
  {
    sectionName: 'Other Provisions',
    sectionKey: 'otherProvisions',
    type: 'dynamic',
    fields: [],
  },
];

export const CustomisationGeneralProvisions = [
  {
    isActive: true,
    commonData: {
      text: '',
    },
    title: 'Rep & Warranties',
  },
  {
    isActive: true,
    commonData: {
      text: '',
    },
    title: 'Confidentiality',
  },
  {
    isActive: true,
    commonData: {
      text: '',
    },
    title: 'Intellectual Property',
  },
  {
    isActive: true,
    commonData: {
      text: '',
    },
    title: 'Liability',
  },
  {
    isActive: true,
    commonData: {
      text: '',
    },
    title: 'Indemnity',
  },
  {
    isActive: true,
    commonData: {
      text: '',
    },
    title: 'Assignment',
  },
  {
    isActive: true,
    commonData: {
      text: '',
    },
    title: 'On-boarding',
  },
  {
    isActive: true,
    commonData: {
      text: '',
    },
    title: 'Entitre Agreement',
  },
  {
    isActive: true,
    commonData: {
      text: '',
    },
    title: 'Independent Contractor',
  },
  {
    isActive: true,
    commonData: {
      text: '',
    },
    title: 'Notices',
  },
  {
    isActive: true,
    commonData: {
      text: '',
    },
    title: 'Enforcement',
  },
  {
    isActive: true,
    commonData: {
      text: '',
    },
    title: 'Additional Provisions',
  },
  {
    isActive: true,
    commonData: {
      text: '',
    },
    title: 'Data Protection',
  },
  {
    isActive: true,
    commonData: {
      text: '',
    },
    title: 'Force Majeure',
  },
  {
    isActive: true,
    commonData: {
      text: '',
    },
    title: 'Announcements',
  },
];

export const SowTabNumber = {
  preliminary: 1,
  projectDescription: 2,
  projectManagement: 3,
  termsAndTermination: 4,
  generalProvisions: 5,
  otherProvisions: 6,
  signature: 8,
};

export const rfpNumber = {
  overview: 0,
  background: 1,
  context: 2,
  scopeAndDeliverables: 3,
  scheduleAndBudget: 4,
  otherRequirements: 5,
  proposalContent: 6,
  rfpProcess: 7,
};

export const characterLimit = {
  city: 150,
  state: 150,
  email: 150,
  street: 200,
  tagline: 150,
  country: 150,
  website: 255,
  lastname: 20,
  firstname: 20,
  customURL: 250,
  middlename: 20,
  socialLink: 255,
  companyName: 250,
  companyOverview: 280,
  publicationTitle: 150,
  professionalSummary: 280,
};

export enum SowTabName {
  'PRELIMINARY' = 'PRELIMINARY',
  'PROJECT_DESCRIPTION' = 'PROJECT_DESCRIPTION',
  'PROJECT_MANAGEMENT' = 'PROJECT_MANAGEMENT',
  'TERMS_AND_CONDITIONS' = 'TERMS_AND_CONDITIONS',
  'GENERAL_PROVISIONS' = 'GENERAL_PROVISIONS',
  'OTHER_PROVISIONS' = 'OTHER_PROVISIONS',
}

export enum SowFieldName {
  // Preliminary
  'INTRODUCTION' = 'INTRODUCTION',
  'CLIENT_INFORMATION' = 'CLIENT_INFORMATION',
  'FIRM_INFORMATION' = 'FIRM_INFORMATION',
  'TERMINOLOGY' = 'TERMINOLOGY',
  'DEFINITION' = 'DEFINITION',
  // Project Description
  'PROJECT_NAME' = 'PROJECT_NAME',
  'PROJECT_CONTEXT' = 'PROJECT_CONTEXT',
  'PROJECT_OBJECTIVES' = 'PROJECT_OBJECTIVES',
  'PROJECT_SCOPE' = 'PROJECT_SCOPE',
  'EXPECTED_SERVICES_CONTEXT' = 'EXPECTED_SERVICES_CONTEXT',
  'EXPECTED_START_DATE' = 'EXPECTED_START_DATE',
  'EXPECTED_END_DATE' = 'EXPECTED_END_DATE',
  'EXPECTED_DURATION' = 'EXPECTED_DURATION',
  'EXPECTED_DELIVERABLES' = 'EXPECTED_DELIVERABLES',
  // Project Management
  'METHODOLOGY' = 'METHODOLOGY',
  'MILESTONES' = 'MILESTONES',
  'PROJECT_ORGANIZATION' = 'PROJECT_ORGANIZATION',
  'STAFFING' = 'STAFFING',
  'PROJECT_GOVERNANCE' = 'PROJECT_GOVERNANCE',
  'LANGUAGE' = 'LANGUAGE',
  'WORK_LOCATION' = 'WORK_LOCATION',
  'STATUS_REPORTS' = 'STATUS_REPORTS',
  'ACCEPTANCE_CRITERIA' = 'ACCEPTANCE_CRITERIA',
  'ASSUMPTIONS' = 'ASSUMPTIONS',
  // Terms & Conditions
  'DETAILED_FEES' = 'DETAILED_FEES',
  'PROJECT_COSTS' = 'PROJECT_COSTS',
  'INVOICING_MILESTONES' = 'INVOICING_MILESTONES',
  'PAYMENT_TERMS' = 'PAYMENT_TERMS',
  'PO_NUMBER' = 'PO_NUMBER',
  'INVOICING_CONTACT' = 'INVOICING_CONTACT',
  'MANAGEMENT_OF_CHANGES' = 'MANAGEMENT_OF_CHANGES',
  'TERMINATION' = 'TERMINATION',
  'CONTRACT_ADMINISTRATION' = 'CONTRACT_ADMINISTRATION',
  'FIXED_FEES' = 'FIXED_FEES',
  'DISCOUNT' = 'DISCOUNT',
  'VARIABLE_FEES' = 'VARIABLE_FEES',
  'OTHERS_FEES' = 'OTHERS_FEES',
  'TRAVEL_AND_EXPENSES' = 'TRAVEL_AND_EXPENSES',
  // General Provisions
  'REPRESENTATIONS_WARRANTIES_COVENANTS' = 'REPRESENTATIONS_WARRANTIES_COVENANTS',
  'CONFIDENTIALITY' = 'CONFIDENTIALITY',
  'INTELLECTUAL_PROPERTY' = 'INTELLECTUAL_PROPERTY',
  'LIABILITY' = 'LIABILITY',
  'INDEMNITY' = 'INDEMNITY',
  'ASSIGNMENT_SUBCONTRACTING' = 'ASSIGNMENT_SUBCONTRACTING',
  'ONBOARDING' = 'ONBOARDING',
  'ENTITRE_AGREEMENT' = 'ENTITRE_AGREEMENT',
  'INDEPENDENT_CONTRACTOR' = 'INDEPENDENT_CONTRACTOR',
  'NOTICES' = 'NOTICES',
  'ENFORCEMENT_SEVERABILITY' = 'ENFORCEMENT_SEVERABILITY',
  'ADDITIONAL_PROVISIONS' = 'ADDITIONAL_PROVISIONS',
  'DATA_PROTECTION' = 'DATA_PROTECTION',
  'FORCE_MAJEURE' = 'FORCE_MAJEURE',
  'ANNOUNCEMENT' = 'ANNOUNCEMENT',
  'INVOICE_CURRENCY' = 'INVOICE_CURRENCY',
}

export enum NdaTabName {
  'PRELIMINARY' = 'PRELIMINARY',
  'CONFIDENTIAL_INFORMATION' = 'CONFIDENTIAL_INFORMATION',
  'TERMS_TERMINATION' = 'TERMS_TERMINATION',
  'OBLIGATIONS' = 'OBLIGATIONS',
  'GENERAL_PROVISIONS' = 'GENERAL_PROVISIONS',
  'OTHER_PROVISIONS' = 'OTHER_PROVISIONS',
}

export enum NdaFieldName {
  // Preliminary
  'INTRODUCTION' = 'INTRODUCTION_PARTIES',
  'CLIENT_INFORMATION' = 'CLIENT_INFORMATION',
  'FIRM_INFORMATION' = 'FIRM_INFORMATION',
  'TERMINOLOGY' = 'TERMINOLOGY',
  'EXPECTED_START_DATE' = 'EXPECTED_START_DATE',
  'EXPECTED_END_DATE' = 'EXPECTED_END_DATE',
  'effectiveDate' = 'EFFECTIVE DATE',
  'termDate' = 'TERM DATE',
  'termText' = 'TERM TEXT',
  'termination' = 'TERMINATION',
  // Confidential information
  'DEFINITION' = 'DEFINITION',
  'EXCLUSIONS' = 'EXCLUSIONS',
  // Obligations
  'DISCLOSING_PARTY' = 'DISCLOSING_PARTY',
  'RECEIVING_PARTY' = 'RECEIVING_PARTY',
}

export enum SowFieldLabel {
  'INTRODUCTION' = 'INTRODUCTION',
  'CLIENT_INFORMATION' = 'CLIENT INFORMATION',
  'FIRM_INFORMATION' = 'FIRM INFORMATION',
  'TERMINOLOGY' = 'TERMINOLOGY',
  'DEFINITION' = 'DEFINITION',
  // Project Description
  'PROJECT_NAME' = 'PROJECT NAME',
  'PROJECT_CONTEXT' = 'PROJECT CONTEXT',
  'PROJECT_OBJECTIVES' = 'PROJECT OBJECTIVES',
  'PROJECT_SCOPE' = 'PROJECT SCOPE',
  'EXPECTED_SERVICES_CONTEXT' = 'EXPECTED SERVICES CONTEXT',
  'EXPECTED_START_DATE' = 'EXPECTED START DATE',
  'EXPECTED_END_DATE' = 'EXPECTED END DATE',
  'EXPECTED_DURATION' = 'EXPECTED DURATION',
  'EXPECTED_DELIVERABLES' = 'EXPECTED DELIVERABLES',
  // Project Management
  'METHODOLOGY' = 'METHODOLOGY & TIMELINE',
  'MILESTONES' = 'PROJECT MILESTONES & DELIVERABLES',
  'PROJECT_ORGANIZATION' = 'PROJECT ORGANIZATION',
  'STAFFING' = 'STAFFING',
  'PROJECT_GOVERNANCE' = 'PROJECT GOVERNANCE',
  'LANGUAGE' = 'LANGUAGE',
  'WORK_LOCATION' = 'WORK LOCATION',
  'STATUS_REPORTS' = 'STATUS REPORTS',
  'ACCEPTANCE_CRITERIA' = 'ACCEPTANCE CRITERIA',
  'ASSUMPTIONS' = 'Assumptions',
  // Terms & Conditions
  'PROJECT_COSTS' = 'PROJECT COSTS',
  'INVOICING_MILESTONES' = 'INVOICING MILESTONES',
  'PAYMENT_TERMS' = 'PAYMENT TERMS',
  'INVOICE_CURRENCY' = 'INVOICE CURRENCY',
  'PO_NUMBER' = 'PO NUMBER',
  'INVOICING_CONTACT' = 'INVOICING CONTACT',
  'MANAGEMENT_OF_CHANGES' = 'MANAGEMENT OF CHANGES',
  'TERMINATION' = 'TERMINATION',
  'CONTRACT_ADMINISTRATION' = 'CONTRACT ADMINISTRATION',
  'FIXED_FEES' = 'FIXED FEES',
  'DISCOUNT' = 'DISCOUNT',
  'VARIABLE_FEES' = 'VARIABLE FEES',
  'OTHERS_FEES' = 'OTHERS FEES',
  'TRAVEL_AND_EXPENSES' = 'TRAVEL AND EXPENSES',
  'DETAILED_FEES' = 'DETAILED FEES',
  // General Provisions
  'REPRESENTATIONS_WARRANTIES_COVENANTS' = 'REPRESENTATIONS, WARRANTIES AND COVENANTS',
  'CONFIDENTIALITY' = 'CONFIDENTIALITY',
  'INTELLECTUAL_PROPERTY' = 'INTELLECTUAL PROPERTY',
  'LIABILITY' = 'LIABILITY',
  'INDEMNITY' = 'INDEMNITY',
  'ASSIGNMENT_SUBCONTRACTING' = 'ASSIGNMENT, SUBCONTRACTING',
  'ONBOARDING' = 'ONBOARDING',
  'ENTITRE_AGREEMENT' = 'ENTITRE AGREEMENT',
  'INDEPENDENT_CONTRACTOR' = 'INDEPENDENT CONTRACTOR',
  'NOTICES' = 'NOTICES',
  'ENFORCEMENT_SEVERABILITY' = 'ENFORCEMENT SEVERABILITY',
  'ADDITIONAL_PROVISIONS' = 'ADDITIONAL PROVISIONS',
  'DATA_PROTECTION' = 'DATA PROTECTION',
  'FORCE_MAJEURE' = 'FORCE MAJEURE',
  'ANNOUNCEMENT' = 'ANNOUNCEMENT',
}

export enum SpecialDiffType {
  'DEFAULT',
}

export const SoWValidationDialogText = {
  title: 'Confirm Validation',
  message: 'Are you sure you want to mark the changes in this field as validated?',
  successMessage: 'SoW field marked as validated',
};

export enum SoWFieldValidationStatus {
  INITIAL = 1,
  PENDING = 2,
  VALIDATED = 3,
}

export enum SoWDataFieldName {
  TEXT = 'text',
  DATE = 'date',
  DURATION = 'duration',
  AMOUNT = 'amount',
  DISCOUNT = 'discount',
  CURRENCY = 'currency',
}

export const StrategicPrioritiesYearMin = 1900;

export const ContractTypeList = [
  {
    value: 1,
    label: 'SoW',
  },
  {
    value: 2,
    label: 'NDA',
  },
  {
    value: 3,
    label: 'MSA',
  },
];

export const ContractTypesToBeListedInAddContracts = [
  {
    value: 1,
    label: 'SoW',
  },
  {
    value: 2,
    label: 'NDA',
  },
  {
    value: 3,
    label: 'MSA',
  },
];

export enum UploadPath {
  CONTRACTS = 'Contracts',
  SUPER_ADMIN_CONTRACTS = 'admin/contracts',
  STRATEGIC_PRIORITIES = 'StrategicPriorities',
  FIRM_SPECIFIC_INFO_DOCUMENTS = 'firm/specificInfoDocuments',
  MEETINGS = 'meetings',
  LIBRARY = 'library',
}

export const ConsultingFirmProfileTabs = [
  {
    routeName: 'Company Profile',
    routeUrl: 'company-profile',
  },
  {
    routeName: 'Legal Entities',
    routeUrl: 'legal-entities',
  },
  {
    routeName: 'Partners',
    routeUrl: 'contacts',
  },
  {
    routeName: 'Projects',
    routeUrl: 'projects',
  },
  {
    routeName: 'Analytics',
    routeUrl: 'analytics',
  },
  {
    routeName: 'Contracts',
    routeUrl: 'administrative',
  },
  {
    routeName: 'Meetings',
    routeUrl: 'meetings',
  },
  {
    routeName: 'Tasks',
    routeUrl: 'tasks',
  },
  {
    routeName: 'Settings',
    routeUrl: 'settings',
  },
];

export const ConsultingFirmProfileTabsFirmSide = [
  {
    routeName: 'General Information',
    routeUrl: 'general-information',
  },
];

export const ConsultingFirmTabsSuperAdminSide = [
  {
    routeName: 'General Information',
    routeUrl: 'general-information',
  },
  {
    routeName: 'Specific Information',
    routeUrl: 'specific-information',
  },
];

export enum ContractsDocumentTypes {
  UploadedDocument = 1,
  DriveLink = 2,
  ProgressiveRFP = 3,
  ProgressiveProposal = 4,
  ProgressiveSow = 5,
}

export enum ConsultingFirmTabs {
  GeneralInformation = 'general-information',
  SpecificInformation = 'specific-information',
  legalEntities = 'legal-entities',
  Contacts = 'contacts',
  Projects = 'projects',
  Analytics = 'analytics',
  Contracts = 'administrative',
  Meetings = 'meetings',
  Actions = 'tasks',
  Locaton = 'location',
}

export const MeetingNatureList = [
  {
    value: 1,
    label: 'Introduction',
  },
  {
    value: 2,
    label: 'Performance Review',
  },
  {
    value: 3,
    label: 'Other',
  },
];

export const SocialUrlRegex = {
  linkedIn: /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(pub|in|profile|company)\/([-a-zA-Z0-9\S]+)\/*/,
  facebook: /(?:(?:http|https):\/\/)?(?:www.)?facebook.com\/(?:(?:\w)*#!\/)?(?:pages\/)?(?:[?\w\-]*\/)?(?:profile.php\?id=(?=\d.*))?([\w\-]*)?/,
  instagram: /(?:(?:http|https):\/\/)?(?:www.)?(?:instagram.com|instagr.am|instagr.com)\/(\w+)/,
  website: /^(https?:\/\/)?([\da-zа-я\.\-_]+)\.([a-zа-я\._]{2,6})([a-zа-я\d\.\-\?\/&=#%_]*)*/,
  twitter: /http(?:s)?:\/\/(?:www\.)?twitter\.com\/([a-zA-Z0-9_]+)/,
  youtube: /(https?:\/\/)?(www\.)?youtube\.com\/(channel|user)\/[\w-]+/,
};
export const WebsiteRegex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
export const FocusChartColors = [
  '#FFA600',
  '#F95D6A',
  '#003F5C',
  '#26D7AE',
  '#FF7C43',
  '#007883',
  '#665191',
  '#97D9FF',
  '#DA006D',
  '#8857B9',
  '#00789D',
  '#A05195',
  '#BB389C',
  '#E00034',
  '#D45087',
  '#5FB7D4',
  '#0074B5',
  '#1BAA2F',
  '#2F4B7C',
  '#456AC1',
];

export const CompanyAnalyticsByRegion = {
  colorForPercentageVal: [
    {
      from: 0.1,
      to: 20,
      color: 'rgba(255, 119, 0, 0.2)',
      label: '< 20%',
    },
    {
      from: 20,
      to: 40,
      color: 'rgba(255, 119, 0, 0.4)',
      label: '20% - 40%',
    },
    {
      from: 40,
      to: 60,
      color: 'rgba(255, 119, 0, 0.6)',
      label: '40% - 60%',
    },
    {
      from: 60,
      to: 80,
      color: 'rgba(255, 119, 0, 0.8)',
      label: '60% - 80%',
    },
    {
      from: 80,
      to: 100,
      color: 'rgba(255, 119, 0, 1.0)',
      label: '80% - 100%',
    },
    {
      from: 0,
      to: 0,
      color: '#E5E5E5',
      label: 'Not assigned',
    },
  ],
  colorForNumberVal: [
    {
      from: 0.01,
      to: 10,
      color: 'rgba(255, 119, 0, 0.2)',
      label: '< 10M',
    },
    {
      from: 10,
      to: 20,
      color: 'rgba(255, 119, 0, 0.4)',
      label: '10M - 20M',
    },
    {
      from: 20,
      to: 30,
      color: 'rgba(255, 119, 0, 0.6)',
      label: '20M - 30M',
    },
    {
      from: 30,
      to: 40,
      color: 'rgba(255, 119, 0, 0.8)',
      label: '30M - 40M',
    },
    {
      from: 40,
      to: 50,
      color: 'rgba(255, 119, 0, 1.0)',
      label: '40M - 50M',
    },
    {
      from: 0,
      to: 0,
      color: '#E5E5E5',
      label: 'Not assigned',
    },
  ],
};

export const CompanyAnalyticsByCapabilites = {
  colorForPercentageVal: [
    {
      from: 0,
      to: 10,
      color: 'rgba(255, 119, 0, 0.1)',
    },
    {
      from: 10,
      to: 20,
      color: 'rgba(255, 119, 0, 0.2)',
    },
    {
      from: 20,
      to: 30,
      color: 'rgba(255, 119, 0, 0.3)',
    },
    {
      from: 30,
      to: 40,
      color: 'rgba(255, 119, 0, 0.4)',
    },
    {
      from: 40,
      to: 50,
      color: 'rgba(255, 119, 0, 0.5)',
    },
    {
      from: 50,
      to: 60,
      color: 'rgba(255, 119, 0, 0.6)',
    },
    {
      from: 60,
      to: 70,
      color: 'rgba(255, 119, 0, 0.7)',
    },
    {
      from: 70,
      to: 80,
      color: 'rgba(255, 119, 0, 0.8)',
    },
    {
      from: 80,
      to: 90,
      color: 'rgba(255, 119, 0, 0.9)',
    },
    {
      from: 90,
      to: 100,
      color: 'rgba(255, 119, 0, 1.0)',
    },
  ],
  colorForNumberVal: [
    {
      from: 0,
      to: 5,
      color: 'rgba(255, 119, 0, 0.1)',
    },
    {
      from: 5,
      to: 10,
      color: 'rgba(255, 119, 0, 0.2)',
    },
    {
      from: 10,
      to: 15,
      color: 'rgba(255, 119, 0, 0.3)',
    },
    {
      from: 15,
      to: 20,
      color: 'rgba(255, 119, 0, 0.4)',
    },
    {
      from: 20,
      to: 25,
      color: 'rgba(255, 119, 0, 0.5)',
    },
    {
      from: 25,
      to: 30,
      color: 'rgba(255, 119, 0, 0.6)',
    },
    {
      from: 30,
      to: 35,
      color: 'rgba(255, 119, 0, 0.7)',
    },
    {
      from: 35,
      to: 40,
      color: 'rgba(255, 119, 0, 0.8)',
    },
    {
      from: 40,
      to: 45,
      color: 'rgba(255, 119, 0, 0.9)',
    },
    {
      from: 45,
      to: 50,
      color: 'rgba(255, 119, 0, 1.0)',
    },
  ],
};

export const CharacterLimit = {
  name: 20,
  companyName: 150,
  email: 150,
  tagline: 150,
  overview: 280,
  address1: 200,
  address2: 150,
  customURL: 250,
  websiteURL: 255,
  socialLinkURL: 255,
  title: 150,
};

export enum CompanyType {
  PrivatelyHeld = 'Privately Held',
  PubilcCompany = 'Public Company',
  NotSpecified = 'Not Specified',
  Partnership = 'Partnership',
  SoleProprietorship = 'Sole Proprietorship',
  Nonprofit = 'Nonprofit',
}

export const EmployeesRange = ['2-10', '11-50', '51-200', '201-500', '501-1,000', '1,001-5,000', '5,001-10,000', '10,001+'];

export const SuggestIndustries = ['Managment Consulting', 'Academia', 'Other'];

export const DiversityList = [
  { label: 'Woman Owned' },
  { label: 'Veteran Owned' },
  {
    label: 'Minority Owned',
  },
  {
    label: 'LGBTQ Owned',
  },
  {
    label: 'Disabled Owned',
  },
];

export const imageQuality = 35;
export const imageRatio = 100;
export const imageUploadFileTypes = '.png, .jpg, .jpeg';
export const imageUploadMaxFileSizeMB = 10;

export enum UploadType {
  'Profile',
  'Cover',
  'ImageAssets',
  'Other',
  'Sow',
  'Nda',
  'Msa',
  'AdminContract',
  'LegalEntity',
  'Chat',
  'Meetings',
  'MsaAppendix',
}

export enum UploadTypes {
  Crop = 'crop',
  Upload = 'upload',
}

export const profilePhotoMaxResolution = {
  width: 118,
  height: 118,
};

export const coverPhotoMaxResolution = {
  width: 388,
  height: 130,
};

export const employeeRanges = ['2-10', '11-50', '51-200', '201-500', '501-1,000', '1,001-5,000', '5,001-10,000', '10,001+'];

export enum ServicedBusiness {
  StartUp = 'Start-ups and Very Small Business',
  Small = 'Small Companies',
  Medium = 'Medium-Sized Companies',
  Large = 'Large Companies',
  Fortune = 'Fortune 1000 Companies',
  NotSpecified = 'Not Specified',
}

export enum Category {
  LAYOUT = 'Layout',
  TEMPLATE = 'Template',
}

export enum CurrencyType {
  CONVERSION = 'Conversion',
  MANAGEMENT = 'Management',
  ARCHIVED = 'Archived',
}

export enum TemplateEditorMode {
  ADD = 'add',
  EDIT = 'edit',
}

export enum TemplateType {
  SOW = 'sow',
  RFP = 'rfp',
  NDA = 'nda',
  MSA = 'msa',
}

export enum ClientRfpSettingsTabs {
  MILESTONES = 'milestones',
  SELECTION_CRITERIA = 'selection-criteria',
  EXPORT_HISTORY = 'export-history',
  SETTINGS = 'settings',
}

export enum ClientSowSettingsTabs {
  EXPORT_HISTORY = 'export-history',
}

export enum ClientSourcingSettingsTabs {
  SETTINGS = 'settings',
  EXPORT_HISTORY = 'export-history',
}

export enum ProjectAnalyticsChartType {
  ProjectByMonth = 'ProjectByMonth',
  ProjectByCapability = 'ProjectByCapability',
  ProjectByOrganisation = 'ProjectByOrganisation',
  ProjectByBusinessUnit = 'ProjectByBusinessUnit',
  ProjectByRegion = 'ProjectByRegion',
}

export const ndaValidationDialogText = {
  title: 'Confirm Validation',
  message: 'Are you sure you want to mark the changes in this field as validated?',
  successMessage: 'NDA field marked as validated',
};

export const ProjectAnalyticsChartColor = [
  {
    from: 1,
    to: 10,
    color: 'rgba(255, 119, 0, 0.2)',
    label: '< 10',
  },
  {
    from: 10,
    to: 20,
    color: 'rgba(255, 119, 0, 0.4)',
    label: '10 - 20',
  },
  {
    from: 20,
    to: 30,
    color: 'rgba(255, 119, 0, 0.6)',
    label: '20 - 30',
  },
  {
    from: 30,
    to: 40,
    color: 'rgba(255, 119, 0, 0.8)',
    label: '30 - 40',
  },
  {
    from: 40,
    to: 50,
    color: 'rgba(255, 119, 0, 1.0)',
    label: '40 - 50',
  },
  {
    from: 0,
    to: 0,
    color: '#E5E5E5',
    label: 'Not assigned',
  },
];

export const SpecificInformationQualificationOptions = [
  {
    key: 'complianceData',
    value: 'Compliance Data',
    documents: [],
  },
  {
    key: 'certificationData',
    value: 'Certification Data',
    documents: [],
  },
  {
    key: 'legalFiscalData',
    value: 'Legal & Fiscal Data',
    documents: [],
  },
  {
    key: 'onboardingData',
    value: 'Other Registration / On Boarding Data',
    documents: [],
  },
];

export enum ActionType {
  RESET = 'reset',
  DELETE = 'delete',
}

export enum ProjectFastTracking {
  RFP = 1,
  SoW = 2,
  PROJECT_MANAGEMENT = 3,
  PERFORMANCE = 4,
  PM = '3',
  PERFORMANCE_MANAGEMENT = '4',
}

export const MarketExplorationCompanySizeFilterValues = ['2-10', '11-50', '51-200', '201-500', '501-1,000', '1,001-5,000', '5,001-10,000', '10,001+'];

export const AvailableModulesList: ConSourceModule[] = [
  { moduleId: 'HOME', name: 'Home', path: '/dashboard', readOnly: true, icon: 'dashboard', roles: [1, 2, 3, 4], visibleInNav: true },
  {
    moduleId: 'DEMAND_MANAGEMENT',
    name: 'Demand Management',
    readOnly: false,
    icon: 'edit_document',
    roles: [1, 2, 3, 4],
    visibleInNav: true,
    children: [
      {
        moduleId: 'STRATEGIC_PRIORITIES',
        name: 'Strategic Priorities',
        path: '/dashboard/demand-management/strategic-priorities',
        readOnly: false,
        visibleInNav: true,
      },
      {
        moduleId: 'APPROVAL_WORKFLOWS',
        name: 'Approval Workflows',
        path: '/dashboard/demand-management/approval-workflows',
        readOnly: false,
        visibleInNav: true,
      },
      { moduleId: 'DEMANDS', name: 'Demands', path: '/dashboard/projects/demands', readOnly: false, visibleInNav: true },
    ],
  },
  {
    moduleId: 'PROJECTS',
    name: 'Projects',
    readOnly: false,
    icon: 'assignment',
    roles: [1, 2, 3, 4],
    visibleInNav: true,
    children: [
      {
        moduleId: 'PROJECT_LIST',
        name: 'Projects',
        path: '/dashboard/projects',
        readOnly: false,
        visibleInNav: true,
      },
      {
        moduleId: 'PROJECT_ANALYTICS',
        name: 'Projects Analytics',
        path: '/dashboard/projects/project-analytics',
        readOnly: false,
        visibleInNav: true,
      },
    ],
  },
  {
    moduleId: 'CONTRACTS',
    name: 'Contracts',
    readOnly: false,
    icon: 'handshake',
    roles: [1, 2, 3, 4],
    visibleInNav: true,
    children: [
      {
        moduleId: 'CONTRACTS_LIST',
        name: 'Contracts',
        path: '/dashboard/administrative/list',
        firmPath: '/invitation-dashboard/administrative/list',
        readOnly: false,
        visibleInNav: true,
      },
      {
        moduleId: 'INVOICES_AND_PAYMENTS',
        name: 'Invoices and Payments',
        path: '/dashboard/administrative/invoices-and-payments',
        firmPath: '/invitareadOnlytion-dashboard/administrative/invoices-and-payments',
        readOnly: false,
        visibleInNav: true,
      },
      {
        moduleId: 'NDA_WIZARD',
        name: 'NDA Wizard',
        firmPath: '/invitation-dashboard/administrative/nda-wizard',
        path: '/dashboard/administrative/nda-wizard',
        readOnly: false,
        visibleInNav: false,
      },
      {
        moduleId: 'MSA_WIZARD',
        name: 'MSA Wizard',
        firmPath: '/invitation-dashboard/administrative/msa-wizard',
        path: '/dashboard/administrative/msa-wizard',
        readOnly: false,
        visibleInNav: false,
      },
    ],
  },
  {
    moduleId: 'PANEL_MANAGEMENT',
    name: 'Panel Management',
    readOnly: false,
    icon: 'domain',
    roles: [1, 2],
    visibleInNav: true,
    children: [
      { moduleId: 'CONSULTING_FIRMS', name: 'Provider Panel', path: '/dashboard/consultingFirm', readOnly: false, visibleInNav: true },
      { moduleId: 'ON_BOARDING', name: 'Legal Entities', path: '/dashboard/panel-management/on-boarding', readOnly: false, visibleInNav: true },
      { moduleId: 'PANEL_ANALYTICS', name: 'Panel Analytics', path: '/dashboard/panel-management/panel-analytics', readOnly: false, visibleInNav: true },
      {
        moduleId: 'PERFORMANCE_MANAGEMENT',
        name: 'Performance Management',
        path: '/dashboard/panel-management/performance-management',
        readOnly: false,
        visibleInNav: true,
      },
      {
        moduleId: 'MARKET_EXPLORATION',
        name: 'Consource Global Network',
        path: '/dashboard/panel-management/consource-global-network',
        readOnly: false,
        visibleInNav: true,
      },
      { moduleId: 'SUGGESTED_FIRM', name: 'Suggested Provider', path: '/dashboard/panel-management/suggested-firm', readOnly: false, visibleInNav: true },
      {
        moduleId: 'RISK_MANAGEMENT',
        name: 'Risk Management',
        path: '/dashboard/panel-management/risk-management',
        readOnly: false,
        visibleInNav: true,
      },
    ],
  },
  {
    moduleId: 'KNOWLEDGE_CENTER',
    name: 'Knowledge Center',
    readOnly: false,
    icon: 'school',
    roles: [1, 2, 3, 4],
    visibleInNav: true,
    children: [
      { moduleId: 'LIBRARY', name: 'Library', path: '/dashboard/knowledge-center/library', readOnly: false, visibleInNav: true },
      {
        moduleId: 'SCS_ACADEMY',
        name: 'SCS Academy',
        path: '/dashboard/knowledge-center/scs-academy',
        readOnly: false,
        visibleInNav: true,
      },
      { moduleId: 'COMMUNITY', name: 'Community', path: '/dashboard/knowledge-center/community', readOnly: false, visibleInNav: true },
    ],
  },
  {
    moduleId: 'CATEGORY_MANAGEMENT',
    name: 'Category Management',
    readOnly: false,
    icon: 'category',
    roles: [1, 2],
    visibleInNav: true,
    children: [
      {
        moduleId: 'COMPANY_ANALYTICS',
        name: 'Company Analytics',
        path: '/dashboard/category-management/company-analytics',
        readOnly: false,
        visibleInNav: true,
      },
      { moduleId: 'OBJECTIVES', name: 'Objectives and Initiatives', path: '/dashboard/category-management/objectives', readOnly: false, visibleInNav: true },
      {
        moduleId: 'PROCESS_ANALYTICS',
        name: 'Process Analytics',
        path: '/dashboard/category-management/process-analytics',
        readOnly: false,
        visibleInNav: true,
      },
      {
        moduleId: 'CONSULTING_BUDGETS',
        name: 'Consulting Budgets',
        path: '/dashboard/category-management/consulting-budgets',
        readOnly: false,
        visibleInNav: true,
      },
    ],
  },
  {
    moduleId: 'ACTIONS',
    name: 'Tasks',
    readOnly: false,
    icon: 'checklist_rtl',
    roles: [1, 2, 3, 4],
    visibleInNav: true,
    children: [
      { moduleId: 'ACTION_ANALYTICS', name: 'Tasks Analytics', path: '/dashboard/tasks/analytics', readOnly: false, visibleInNav: true },
      { moduleId: 'ALL_ACTIONS', name: 'All Tasks', path: '/dashboard/tasks/all-tasks', readOnly: false, roles: [1], visibleInNav: true },
      { moduleId: 'MY_ACTIONS', name: 'My Tasks', path: '/dashboard/tasks/my-tasks', readOnly: false, visibleInNav: true },
    ],
  },
  // {
  //   moduleId: 'PAYMENTS',
  //   name: 'Account & Billing',
  //   icon: 'payments',
  //   readOnly: false,
  //   visibleInNav: true,
  //   roles: [1],
  //   children: [
  //     { moduleId: 'PAYMENTS', name: 'Account & Billing', path: '/dashboard/account-info/accounts-billing', readOnly: false, visibleInNav: true },
  //     { moduleId: 'ACTIVITY', name: 'Activity', path: '/dashboard/account-info/activity', readOnly: false, visibleInNav: true },
  //   ],
  // },
  {
    moduleId: 'ADMIN',
    name: 'Admin',
    icon: 'admin_panel_settings',
    readOnly: false,
    visibleInNav: true,
    roles: [1],
    children: [
      { moduleId: 'USER_LIST', name: 'Users', path: '/dashboard/users', readOnly: false, visibleInNav: true },
      { moduleId: 'USER_INVITE_REQUESTS', name: 'User Invite Requests', path: '/dashboard/users/invite-requests', readOnly: false, visibleInNav: true },
      { moduleId: 'ACCOUNT_BILLING', name: 'Account & Billing', path: '/dashboard/account-info/accounts-billing', readOnly: false, visibleInNav: true },
      { moduleId: 'ACTIVITY', name: 'Activity', path: '/dashboard/account-info/activity', readOnly: false, visibleInNav: true },
    ],
  },
  {
    moduleId: 'SETTINGS',
    name: 'Settings',
    readOnly: true,
    icon: 'settings',
    roles: [1],
    visibleInNav: true,
    children: [{ moduleId: 'CUSTOMISATION', name: 'Customisation', path: '/dashboard/otherSettings', readOnly: false, visibleInNav: true }],
  },
];

export const clientManagementModuleObject = [
  {
    name: 'Clients',
    path: '/dashboard/clients',
  },
  {
    name: 'Client Billing',
    path: '/dashboard/clients/billings',
  },
  {
    name: 'Admin Change Requests',
    path: '/dashboard/clients/admin-change-requests',
  },
];

export const adminProviderManagementModuleObject = [
  {
    name: 'Providers',
    path: '/dashboard/consulting-firms',
  },
  {
    name: 'Suggested Providers',
    path: '/dashboard/suggest-firms',
  },
  {
    name: 'Pending Legal Entities',
    path: '/dashboard/legal-entities',
  },
  {
    name: 'Changes Requested Legal Entities',
    path: '/dashboard/legal-entities/change-request',
  },
  {
    name: 'Providers Billing',
    path: '/dashboard/consulting-firms/billings',
  },
  {
    name: 'Providers Admin Change Request',
    path: '/dashboard/providers/admin-change-requests',
  },
];

export const adminTaxonomyManagementModuleObject = [
  {
    name: 'Industries',
    path: '/dashboard/industries',
  },
  {
    name: 'Capabilities',
    path: '/dashboard/capabilities',
  },
  {
    name: 'Regions',
    path: '/dashboard/regions',
  },
  {
    name: 'Countries',
    path: '/dashboard/countries',
  },
];

export const adminLocalizationManagementModuleObject = [
  {
    name: 'Email Templates',
    path: '/dashboard/emails',
  },
  {
    name: 'Notification Templates',
    path: '/dashboard/notification-contents',
  },
  {
    name: 'Survey Questions',
    path: '/dashboard/questions',
  },
];

export const adminScsManagementModuleObject = [
  {
    name: 'Content',
    path: '/dashboard/scsAcademy',
  },
  {
    name: 'Categories',
    path: '/dashboard/blogCatagory',
  },
];

export enum AdminClientListDrawerType {
  FILTER,
  MANAGE_MODULES,
  INVITE_USER,
}

export const TeamScoringColumnNames = ['Average', 'Median'];

export enum NdaOtherTabsType {
  MISCELLANEOUS = 'miscellaneous',
  OTHERCLAUSES = 'otherClauses',
}

export enum CompanyAnalyticsCharts {
  spendTrend = 0,
  consultingSpend = 1,
  consultingScore = 2,
}

export enum ChartsScreenType {
  Dashboard = 'dashboard',
  CompanyAnalytics = 'company_analytics',
}
export const NdaTabDetails = {
  preliminaryInfo: {
    tabName: 'Preliminary Info',
    fields: {
      introduction: 'Introduction & Parties',
      clientInformation: 'Client Information',
      firmInformation: 'Firm Information',
      terminology: 'Terminology & Acronyms',
      expectedStartDate: 'Expected Start Date',
      expectedEndDate: 'Expected End Date',
    },
  },
  TermsAndTermination: {
    tabName: 'Terms & Termination',
  },
  confidentialInfo: {
    tabName: 'Confidential Information',
    fields: {
      definitions: 'Definition of Confidential Information',
      exclusions: 'Exclusions from Confidential Information',
    },
  },
  obligations: {
    tabName: 'Obligations',
    fields: {
      disclosingPartyObligations: 'Obligations of Disclosing Party',
      receivingPartyObligations: 'Obligations of Receiving Party',
    },
  },
  generalProvisions: { tabName: 'General Provisions' },
  otherProvisions: { tabName: 'Other Provisions' },
};

export const defaultProfilePhoto = 'assets/images/user-image.png';
export const DefaultGroupPhoto = 'assets/images/user.png';

export const ProjectSteps = ['Demand', 'RFP', 'Sourcing & Invitation', 'Q&A', 'Selection', 'SOW', 'Project Management', 'Performance'];

export const ProjectStepsFirm = ['RFP', 'Q&A', 'Selection', 'SOW', 'Project Management', 'Performance'];
export const defaultTextDiffValues = { firmData: { text: '' }, commonData: { text: '' }, clientData: { text: '' } };
export const defaultDateDiffValues = { firmData: { date: '' }, commonData: { date: '' }, clientData: { date: '' } };

export const TermTerminationTab = [
  {
    title: '2_1_Effective_date',
    type: 'default',
    fieldType: 'date',
    placeholder: 'Effective Date',
    fieldName: 'effectiveDate',
    key: 'EFFECTIVE_DATE',
    value: defaultDateDiffValues,
  },
  {
    title: '2_2_Term',
    type: 'dateAndText',
    fieldType: 'dateAndText',
    placeholder: 'Term',
    textFieldName: 'termText',
    dateFieldName: 'termDate',
    datePlaceholder: 'Term Date',
    key: 'TERM',
    date: defaultDateDiffValues,
    text: defaultTextDiffValues,
  },
  {
    title: '2_3_Termination',
    type: 'default',
    fieldType: 'text',
    placeholder: 'Termination',
    key: 'TERMINATION',
    fieldName: 'termination',
    value: defaultTextDiffValues,
  },
  {
    title: '2_4_Renewal_Date',
    type: 'default',
    fieldType: 'date',
    placeholder: 'Renewal Date',
    key: 'RENEWAL_DATE',
    fieldName: 'renewalDate',
    value: defaultDateDiffValues,
  },
];

export enum TermsAndTermination {
  EFFECTIVE_DATE = 'EFFECTIVE_DATE',
  TERM = 'TERM',
  TERMINATION = 'TERMINATION',
  RENEWAL_DATE = 'RENEWAL_DATE',
}

export enum BlogEditorMode {
  ADD = 'Add',
  EDIT = 'Edit',
  DELETE = 'Delete',
}
export enum SignatureStep2Title {
  FinalVersion = 'Final Executed Version',
  ClientVersion = 'Version signed by client',
  FirmVersion = 'Version signed by provider',
  Initial = 'Signature',
}

export const SignatureDefaultText =
  '<p>IN WITNESS WHEREOF, the parties, intending to be legally bound, have caused this Agreement to be executed by their duly authorized representatives, as of the Effective Date.</p>';

export enum DrawerNames {
  MilestoneCriteria = 'MilestoneCriteria',
  RiskDrawer = 'RiskDrawer',
  OnBoardingDrawer = 'onboardingDrawer',
}

export const BlogCatagories = ['Consulting Market', 'Best Practices', 'Webinars', 'Miscellaneous'];

export const DiversityOptions = ['Woman Owned', 'Veteran Owned', 'Minority Owned', 'LGBTQ Owned', 'Disabled Owned'];

export enum TargetProfileTypes {
  Diversity = 'Diversity',
  CompanySize = 'CompanySize',
}

export enum DemographyKey {
  Capability = 'capability',
  Industry = 'industry',
  ChildCapability = 'childCapability',
  ChildIndustry = 'childIndustry',
}

export const CommonCommentsIdKeyValue = {
  msa: 'msaId',
  nda: 'ndaId',
  sow: 'sowId',
};

export enum ProjectListType {
  OPPORTUNITIES = 'opportunities',
  PROJECTS = 'projects',
}

export const MsaTabDetails = {
  preliminaryInfo: {
    tabName: 'Preliminary Info',
    fields: {
      introduction: 'Introduction',
      terminology: 'Terminology & Acronyms',
    },
  },
  TermsAndTermination: {
    tabName: 'Terms & Termination',
  },
  generalProvisions: { tabName: 'General Provisions' },
  otherProvisions: { tabName: 'Other Provisions' },
};

export enum MsaTabName {
  'PRELIMINARY_INFO' = 'PRELIMINARY_INFO',
  'TERMS_TERMINATION' = 'TERMS_TERMINATION',
  'GENERAL_PROVISIONS' = 'GENERAL_PROVISIONS',
  'OTHER_PROVISIONS' = 'OTHER_PROVISIONS',
}

export enum MsaFieldName {
  'INTRODUCTION' = 'INTRODUCTION',
  'terminology' = 'TERMINOLOGY',
  'effectiveDate' = 'EFFECTIVE DATE',
  'termDate' = 'TERM DATE',
  'termText' = 'TERM TEXT',
  'termination' = 'TERMINATION',
  'GENERAL_PROVISIONS' = 'GENERAL_PROVISIONS',
  'OTHER_PROVISIONS' = 'OTHER_PROVISIONS',
}

export const MsaValidationDialogText = {
  title: 'Confirm Validation',
  message: 'Are you sure you want to mark the changes in this field as validated?',
  successMessage: 'MSA field marked as validated',
};

export const PreliminaryTabValues = [
  {
    title: '1_1_Introduction & Parties',
    type: 'text',
    fieldType: 'text',
    placeholder: 'Introduction & Parties',
    fieldName: 'introduction',
    key: 'INTRODUCTION',
    noDiffText: '',
  },
  {
    title: '1_2_Definitions',
    type: 'default',
    fieldType: 'text',
    placeholder: 'Definitions',
    key: 'TERMINOLOGY',
    fieldName: 'terminology',
    value: defaultTextDiffValues,
  },
];

export enum PreliminaryFields {
  INTRODUCTION = 'INTRODUCTION',
  TERMINOLOGY = 'TERMINOLOGY',
}

export const definitionTab = ['ndaPreliminaryTerminologyTerm', 'ndaPreliminaryTerminologyDefinition', 'ndaPreliminaryTerminologyDate', 'ndaPreliminaryAction'];

export const MsaDynamicTabNumbers = {
  Services: 3,
  'Standards of Performance': 4,
  'General Provisions': 5,
  'Other Provisions': 6,
  Appendix: 7,
};

export const MsaDynamicTabRoute = {
  Services: 'services',
  'Standards of Performance': 'standards-performance',
  'General Provisions': 'general-provisions',
  'Other Provisions': 'other-provisions',
  Appendix: 'appendix-sections',
};

export const MsaDynamicFieldName = {
  Services: 'services',
  'Standards of Performance': 'standardsOfPerformance',
  'General Provisions': 'generalProvisions',
  'Other Provisions': 'otherProvisions',
  Appendix: 'appendix',
};
export const MsaDynamicTabNames = ['Services', 'Standards of Performance', 'General Provisions', 'Other Provisions', 'Appendix'];

export const MsaDynamicTabKey = {
  Services: 'SERVICES',
  'Standards of Performance': 'STANDARDS_OF_PERFORMANCE',
  'General Provisions': 'GENERAL_PROVISIONS',
  'Other Provisions': 'OTHER_PROVISIONS',
  Appendix: 'APPENDIX',
};

export const MsaDynamicFieldFilePath = {
  Services: 'contract/msa/services',
  'Standards of Performance': 'contract/msa/sop',
  'General Provisions': 'contract/msa/general-provisions',
  'Other Provisions': 'contract/msa/other-provisions',
  Appendix: 'contract/msa/appendix',
};

export const allDynamicFieldName = ['services', 'standardsOfPerformance', 'generalProvisions', 'otherProvisions', 'appendix'];

export const SowAndNdaDynamicTabNames = ['General Provisions', 'Other Provisions'];
export enum DynamicFieldDataTypes {
  QUILL = 'quill',
  UPLOAD = 'upload',
  TEMPLATE = 'template',
}

export const SoWDynamicFieldValues = {
  'General Provisions': [
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Rep & Warranties',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Confidentiality',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Intellectual Property',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Liability',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Indemnity',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Assignment',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'On-boarding',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Entitre Agreement',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Independent Contractor',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Notices',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Enforcement',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Additional Provisions',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Data Protection',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Force Majeure',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Announcements',
    },
  ],
  'Other Provisions': [],
};

export const NdaDynamicFieldValues = {
  'General Provisions': [],
  'Other Provisions': [],
};

export const MsaDefaultDynamicFieldsValues = {
  Services: [],
  'Standards of Performance': [],
  'General Provisions': [
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Billing And Payment',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Right to Audit',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Confidentiality',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Indemnity & Liability',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Termination',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Intellectual Property',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Warranties',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Publicity & Publication',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Business Identifiers',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Independent Contractor',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Business Continuity',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'Force Majeure',
    },
    {
      isActive: true,
      commonData: {
        text: '',
      },
      type: DynamicFieldDataTypes.QUILL,
      title: 'No Exclusion',
    },
  ],
  'Other Provisions': [],
  Appendix: [],
};

export const AllDynamicKeyName = {
  services: 'Services',
  standardsOfPerformance: 'Standards of Performance',
  generalProvisions: 'General Provisions',
  otherProvisions: 'Other Provisions',
  appendix: 'Appendix',
};

export const RationalOptions = {
  'I want to invite this company on a project': 1,
  'I want to add the company to my panel': 2,
  'Just for your information': 3,
};

//TODO: Make sure to update whenever Improveo CommunityImpactList is updated
export const ImproveoCompanyCommunityImpactList = [
  {
    _id: '0',
    name: 'Offers Pro Bono Services',
  },
  {
    _id: '1',
    name: 'Offers Discounts for NGOs',
  },
];

//TODO: Make sure to update whenever Improveo Diversity is updated
export const ImproveoCompanyDiversityList = [
  {
    _id: 'Woman Owned',
    name: 'Woman Owned',
  },
  {
    _id: 'Veteran Owned',
    name: 'Veteran Owned',
  },
  {
    _id: 'Minority Owned',
    name: 'Minority Owned',
  },
  {
    _id: 'LGBTQ Owned',
    name: 'LGBTQ Owned',
  },
  {
    _id: 'Disabled Owned',
    name: 'Disabled Owned',
  },
];

export const urlBeginsWithHttp = /^(http|https):/;
export enum GeneralInfoTabs {
  ABOUT = 'about',
  OFFICES = 'offices',
  PUBLICATIONS = 'publications',
  OFFERINGS = 'offerings',
  CASE_STUDY = 'caseStudy',
}

export enum OfferingSectionsName {
  ConsultingIndustries = 'Consulting Solutions By Industry',
  ConsultingCapabilities = 'Consulting Solutions By Capability',
  DigitalIndustires = 'Digital Solutions By Industry',
  DigitalCapabilities = 'Digital Solutions By Capability',
}

export const HtmlListTagsMatch = /(<([(ul|ol|li|/a)>]+)>)/g;
export const HtmlImgTagMatch = /(<img)/g;
export const HtmlBackQuoteMatch = /(<(blockquote)>)/g;

export const HelpRedirectLink = 'https://support.consource.io';

export const InvoicingTable = [
  { columnDef: 'invoiceNumber', header: ' #', cssSelector: 'i', sort: false, key: 'invoiceNumber', type: 'text' },
  { columnDef: 'projectName', header: 'PROJECT', cssSelector: 'project-name', sort: true, key: 'projectName', type: 'text' },
  { columnDef: 'firmName', header: 'PROVIDER', cssSelector: 'firm-name', sort: true, key: 'firmName', type: 'photoName', photoKey: 'firmPhoto' },
  { columnDef: 'companyName', header: 'COMPANY', cssSelector: 'company-name', sort: true, key: 'companyName', type: 'photoName', photoKey: 'companyPhoto' },
  { columnDef: 'invoice', header: 'INVOICING MILESTONE', cssSelector: 'invoice', sort: true, key: 'invoice', type: 'text' },
  // { columnDef: 'invoiceDoc', header: 'INVOICE', cssSelector: 'invoice', sort: true, key: 'invoiceDocument', type: 'invoiceDoc' }, // Moved this column to actions
  { columnDef: 'actualAmount', header: 'ACTUAL AMOUNT', cssSelector: 'act-amount', sort: true, key: 'actualAmount', type: 'textWithSymbol' },
  { columnDef: 'submittedOn', header: 'SUMITTED ON', cssSelector: 'submitted-on', sort: true, key: 'submittedOn', type: 'date' },
  { columnDef: 'approvalStatus', header: 'APPROVAL STATUS', cssSelector: 'approval-status', sort: false, type: 'invoiceApprovalStatus', key: 'status' },
  { columnDef: 'targetPaymentDate', header: 'TARGET PAYMENT DATE', cssSelector: 'target-payment-date', sort: false, key: 'targetPaymentDate', type: 'date' },
  { columnDef: 'paymentStatus', header: 'PAYMENT STATUS', cssSelector: 'approval-status', sort: false, key: 'paymentStatus', type: 'paymentStatus' },
  { columnDef: 'paymentDate', header: 'DATE', cssSelector: 'payment-date', sort: false, key: 'paymentDoneOn', type: 'date' },
  { columnDef: 'invoiceActions', header: 'ACTION', cssSelector: 'delete', sort: false, type: 'invoiceActions', key: 'projectId' },
];
// Need to verify
// { columnDef: 'estAmount', header: 'Estimated Amount', cssSelector: 'est-amount', sort: true, key: 'amount', type: 'text' },
// { columnDef: 'estDate', header: 'Estimated Date', cssSelector: 'est-date', sort: true, key: 'estimatedDate', type: 'date' },
// { columnDef: 'invoiceDoc', header: 'Invoice_', cssSelector: 'invoice', sort: true, key: 'invoiceDocument', type: 'invoiceDoc' },
// { columnDef: 'actualDate', header: 'Actual Date', cssSelector: 'act-date', sort: true, key: 'actualDate', type: 'date' },
// { columnDef: 'submittedBy', header: 'By', cssSelector: 'submitted-by', sort: true, key: 'submittedBy', type: 'photoName', photoKey: 'submittedByPhoto' },
// { columnDef: 'approvedBy', header: 'By', cssSelector: 'approval-by', sort: true, key: 'approvedBy', type: 'photoName', photoKey: 'approvedByPhoto' },
// { columnDef: 'approvedOn', header: 'Date', cssSelector: 'approval-date', sort: true, key: 'approvedOn', type: 'date' },
// { columnDef: 'paymentBy', header: 'By', cssSelector: 'payment-by', sort: false, key: 'paymentDoneBy', type: 'text' },

export const ProjectManagementInvoicingTable = [
  { columnDef: 'invoiceNumber', header: '#', cssSelector: '', sort: false, key: 'invoiceNumber', type: 'text' },
  { columnDef: 'invoice', header: 'INVOICING MILESTONE', cssSelector: 'invoice', sort: false, key: 'invoice', type: 'text' },
  {
    columnDef: 'invoiceDocProjectManagement',
    header: 'INVOICE',
    cssSelector: 'invoice',
    sort: false,
    key: 'invoiceDocument',
    type: 'invoiceDocProjectManagement',
  },
  { columnDef: 'actualAmount', header: 'ACTUAL AMOUNT', cssSelector: 'act-amount', sort: true, key: 'actualAmountInInvoiceCurrency', type: 'actualAmount' },
  { columnDef: 'submittedOn', header: 'SUBMITTED ON', cssSelector: 'submitted-on', sort: true, key: 'submittedOn', type: 'date' },
  {
    columnDef: 'approvalStatus',
    header: 'APPROVAL STATUS',
    cssSelector: 'approval-status',
    sort: false,
    type: 'invoiceApprovalStatusProjectManagement',
    key: 'status',
  },
  { columnDef: 'targetPaymentDate', header: 'TARGET PAYMENT DATE', cssSelector: 'target-payment-date', sort: false, key: 'targetPaymentDate', type: 'date' },
  {
    columnDef: 'paymentStatusProjectManagement',
    header: 'PAYMENT STATUS',
    cssSelector: 'approval-status',
    sort: false,
    key: 'paymentStatus',
    type: 'paymentStatusProjectManagement',
  },
  { columnDef: 'paymentDate', header: 'DATE', cssSelector: 'payment-date', sort: false, key: 'paymentDoneOn', type: 'date' },
  {
    columnDef: 'invoiceActionsProjectManagement',
    header: 'ACTION',
    cssSelector: 'delete',
    sort: false,
    type: 'invoiceActionsProjectManagement',
    key: 'projectId',
  },
];
// Need to verify
// { columnDef: 'estAmount', header: 'Estimated Amount', cssSelector: 'est-amount', sort: true, key: 'amount', type: 'text' },
// { columnDef: 'projectCurrency', header: 'Company Currency', cssSelector: '', sort: false, key: 'companyCurrency', type: 'text' },
// { columnDef: 'estDate', header: 'Estimated Date', cssSelector: 'est-date', sort: true, key: 'estimatedDate', type: 'date' },
// { columnDef: 'actualDate', header: 'Actual Date', cssSelector: 'act-date', sort: true, key: 'actualDate', type: 'date' },
// { columnDef: 'submittedBy', header: 'By', cssSelector: 'submitted-by', sort: true, key: 'submittedBy', type: 'photoName', photoKey: 'submittedByPhoto' },
// { columnDef: 'approvedBy', header: 'By', cssSelector: 'approval-by', sort: true, key: 'approvedBy', type: 'photoName', photoKey: 'approvedByPhoto' },
// { columnDef: 'approvedOn', header: 'Date', cssSelector: 'approval-date', sort: true, key: 'approvedOn', type: 'date' },
// { columnDef: 'paymentBy', header: 'By', cssSelector: 'payment-by', sort: false, key: 'paymentDoneBy', type: 'text' },

export enum AdminSettingsDrawerType {
  LANGUAGES,
  CONVERSION,
  MANAGEMENT,
  FILE_FORMAT,
  ACTIONS,
  COUNTRIES,
}

export const CurrencyConversion = [
  { columnDef: 'currency', header: 'Currency', cssSelector: 'currency', sort: true, key: 'currencyCode', type: 'CurrencySymbol' },
  { columnDef: 'conversion', header: 'Conversion Rate', cssSelector: 'conversion', sort: true, key: 'conversionValue', type: 'textWithEdit' },
  { columnDef: 'validity', header: 'validity Date', cssSelector: 'valid-date', sort: true, key: 'validity', type: 'date' },
  { columnDef: 'currencyActions', header: 'Action', cssSelector: 'edit', sort: false, type: 'currencyActions', key: '_id' },
];
export enum UpdateStatus {
  Initial,
  Success,
  Failed,
}

export const SuperAdminClientTab = {
  billing: 'Billing',
  'accounts-billing': 'Account & Billing',
  'module-management': 'Module Management',
  activity: 'Activity',
};

export enum SuperAdminClientsTab {
  Billing = 'billing',
  Account = 'account',
  ModuleManagement = 'module-management',
}

export enum ClientAccountTypes {
  Plan = 'Plan',
  Contract = 'Contract',
  AdministrativeInfo = 'Billing Info',
  FirmContract = 'Firm Contract',
}

export const clientAccountTypeForQuery = {
  Plan: 'plan',
  Contract: 'contract',
  'Billing Info': 'administrativeInfo',
};

export const PlanOptions = ['Subscription'];
export const PlanNatures = ['Trial', 'Regular', 'Managed services'];
export const TimePeriodOptions = {
  '12 Months': 12,
};
export const RenewalTypeOptions = { 'Auto Renewal': 'autoRenewal' };

export const AlphaNumericRegex = /^[a-zA-Z0-9]*$/;

export const zeroToHundredWithDecimalsRegex = /^(((([1-9][0-9]?)|(100))(\.\d+)?)|(0.[1-9][0-9]*))$/;

export const nonZeroNumbers = '^(0*[1-9][0-9]*(.[0-9]+)?|0+.[0-9]*[1-9][0-9]*)$';

export const DefaultAccountPlan = {
  planType: 'Subscription',
  poNumber: '',
  startDate: '',
  endDate: '',
  timePeriod: 12,
  renewalType: 'autoRenewal',
};

export const DefaultAccountAdministrativeInfo = {
  accountCreatedDate: '',
  adminEmail: '',
  billingInfo: {
    billingContact: '',
    billingAddress: {
      line1: '',
      line2: '',
      city: '',
      state: '',
      country: '',
      zipCode: '',
    },
  },
  applicableTax: '',
};

export enum InvoiceStatus {
  OPEN = 'open',
  PAID = 'paid',
  DRAFT = 'draft',
  VOID = 'void',
  UNCOLLECTIBLE = 'uncollectible',
  PAID_OUT_OF_BAND = 'paid_out_of_band',
}
export const NotificationContentTemplatesColumns = [
  { columnDef: 'templateName', header: 'TEMPLATE NAME', cssSelector: 'element-name', sort: true, key: 'templateName', type: 'text' },
  { columnDef: 'iconName', header: 'ICON', cssSelector: '', sort: false, key: 'iconName', type: 'icon' },
  { columnDef: 'categoryName', header: 'CATEGORY', cssSelector: '', sort: false, key: 'categoryName', type: 'text' },
  { columnDef: 'language', header: 'LANGUAGE', cssSelector: '', sort: false, key: 'languageName', type: 'titleCaseText' },
  { columnDef: 'editNotificationContent', header: 'ACTION', cssSelector: '', sort: false, type: 'edit' }, //TODO
];

export enum BoardingStatus {
  Start = 'start',
  OnGoing = 'onGoing',
  Approved = 'approved',
}

export enum OnBoardingEditDrawerType {
  AddSection,
  AddQuestion,
  EditSection,
  EditQuestion,
}

export enum OnBoardingAnswerType {
  Input = 'input',
  RadioButton = 'radioButton',
  Template = 'template',
  Upload = 'upload',
}

export const OnBoardingKeyType = {
  0: 'questions',
  1: 'question',
  2: 'question',
  3: 'question',
};

export const OnBoardingDrawerTitle = {
  0: 'Add Section',
  1: 'Add Question',
  2: 'Edit Section',
  3: 'Edit Question',
};

export const OnBoardingVisibility = {
  0: { isSectionEditable: true, isSectionVisible: true, isQuestionVisible: false, isMultipleQuestions: false },
  1: { isSectionEditable: false, isSectionVisible: true, isQuestionVisible: true, isMultipleQuestions: false },
  2: { isSectionEditable: true, isSectionVisible: true, isQuestionVisible: false, isMultipleQuestions: false },
  3: { isSectionEditable: false, isSectionVisible: true, isQuestionVisible: true, isMultipleQuestions: false },
};

export const DefaultDrawerDetails = {
  0: { sectionName: '' },
  1: { sectionName: '', questions: [{ question: '', answerType: '' }] },
};

export const ClientOnBoardingTable = [
  { columnDef: 'client', header: 'Clients', cssSelector: 'element-name', sort: false, key: 'name', type: 'text', tip: '' },
  { columnDef: 'companyName', header: 'Company Name', cssSelector: 'client', sort: false, key: 'companyName', type: 'text', tip: '' },
  { columnDef: 'project', header: 'No of Projects', cssSelector: 'project', sort: false, key: 'projectCount', type: 'text', tip: '' },
  { columnDef: 'status', header: 'Status', cssSelector: 'approval-status', sort: false, key: 'onBoardingStatus', type: 'entityApprovalStatus', tip: '' },
  {
    columnDef: 'onBoardingActions',
    header: 'ACTION',
    cssSelector: 'edit',
    sort: false,
    type: 'viewOnboardingData',
    key: { entityId: 'entityId', clientId: 'clientId' },
    tip: 'View Onboarding Data',
  },
];

export const ChatSocketEvents = {
  SendMessage: 'send_message',
  IncomingMessage: 'incoming_message',
  RoomUnreadCount: 'room_unread_count',
  UserUnreadCount: 'user_unread_count',
  OnlineStatus: 'online_status',
};

export const RequestChangeStatus = ['approved', 'change-request'];

export enum chatType {
  'MESSAGE' = 1,
  'DOCUMENT' = 2,
}

export const ALLOWED_FILES_TYPES = ['.pdf', '.jpeg', '.png', '.xls', '.xlsx', '.doc', '.docx'];

export enum LINKS_ACTION_TYPE {
  'CREATE' = 1,
  'UPDATE' = 2,
  'DELETE' = 3,
  'CLOSE' = 4,
}

export enum DOCUMENT_TYPE {
  'LINK' = 1,
  'DOCUMENT' = 2,
}

export const WorspackeDrawerType = {
  TASK: 'tasks',
  LINK: 'links',
  Meetings: 'meetings',
};

export const AddMeetingNatureType = {
  'Project Workspace': 'projectWorkspace',
  Provider: 'consultingFirm',
};

export const ClientRiskTable = [
  { columnDef: 'riskName', header: 'RISK NAME', cssSelector: 'element-name', sort: false, key: 'name', type: 'text', tip: '' },
  { columnDef: 'riskLight', header: 'RISK LEVEl', cssSelector: 'client', sort: false, key: 'light', type: 'riskLevel', tip: '' },
  { columnDef: 'likelihood', header: 'LIKELIHOOD', cssSelector: 'client', sort: false, key: 'likelihood', type: 'riskLevel', tip: '' },
  { columnDef: 'impact', header: 'IMPACT', cssSelector: 'client', sort: false, key: 'impact', type: 'riskLevel', tip: '' },
  { columnDef: 'riskComment', header: 'COMMENT', cssSelector: 'element-name', sort: false, key: 'comments', type: 'text', tip: '' },
  { columnDef: 'riskcreatedDate', header: 'CREATED', cssSelector: 'client', sort: false, key: 'createdAt', type: 'date', tip: '' },
  { columnDef: 'riskUpdatedDate', header: 'LAST UPDATED', cssSelector: 'client', sort: false, key: 'lastUpdated', type: 'date', tip: '' },
  {
    columnDef: 'riskAction',
    header: 'ACTION',
    cssSelector: 'delete',
    sort: false,
    type: 'riskAction',
    key: '_id',
    tip: 'Delete',
  },
];

export const ClientArchivedRiskTable = [
  { columnDef: 'riskName', header: 'RISK NAME', cssSelector: 'element-name', sort: false, key: 'name', type: 'text', tip: '' },
  { columnDef: 'riskLight', header: 'LEVEL', cssSelector: 'client', sort: false, key: 'light', type: 'riskLevel', tip: '' },
  { columnDef: 'likelihood', header: 'LIKELIHOOD', cssSelector: 'client', sort: false, key: 'likelihood', type: 'riskLevel', tip: '' },
  { columnDef: 'impact', header: 'IMPACT', cssSelector: 'client', sort: false, key: 'impact', type: 'riskLevel', tip: '' },
  { columnDef: 'riskComment', header: 'COMMENT', cssSelector: 'element-name', sort: false, key: 'comments', type: 'text', tip: '' },
  { columnDef: 'riskcreatedDate', header: 'CREATED', cssSelector: 'client', sort: false, key: 'createdAt', type: 'date', tip: '' },
  { columnDef: 'riskUpdatedDate', header: 'LAST UPDATED', cssSelector: 'client', sort: false, key: 'lastUpdated', type: 'date', tip: '' },
  {
    columnDef: 'riskUnArchive',
    header: 'ACTION',
    cssSelector: 'unArchive',
    sort: false,
    type: 'riskUnArchive',
    key: '_id',
    tip: 'UnArchive',
  },
];

export const LightList = [
  {
    value: 1,
    label: 'Red',
  },
  {
    value: 2,
    label: 'Amber',
  },
  {
    value: 3,
    label: 'Green',
  },
];

export const riskLevel = [
  {
    value: 'red',
    label: 'Red',
  },
  {
    value: 'amber',
    label: 'Amber',
  },
  {
    value: 'green',
    label: 'Green',
  },
];

export const LikelihoodList = [
  {
    value: 1,
    label: 'Red',
  },
  {
    value: 2,
    label: 'Green',
  },
];

export const LightListPriority = {
  high: 1,
  medium: 2,
  low: 3,
};

export const TemplateDrawerType = {
  DEMAND: 'demand',
  LEGAL_ENTITY: 'legalEntity',
};

export const FieldKeyBasedOnType = {
  quill: 'text',
  upload: 'document',
  template: 'template',
};

export enum MSAFieldType {
  TEXT,
  UPLOAD,
  TEMPLATE,
}

export enum RfpTabs {
  OVERVIEW = 0,
  BACKGROUND = 1,
  CONTEXT = 2,
  SCOPE_DELIVERABLES = 3,
  SCHEDULE_BUDGET = 4,
  OTHER_REQUIREMENTS = 5,
  PROPOSAL_CONTENT = 6,
  RFP_PROCESS = 7,
  ASSOCIATED_DOCS = 8,
}

export const AdminRiskTable = [
  { columnDef: 'riskName', header: 'RISK CATEGORY', cssSelector: 'element-name', sort: false, key: 'name', type: 'text', tip: '' },
  { columnDef: 'riskDefault', header: 'DEFAULT', cssSelector: 'riskDefault', sort: false, key: 'isDefault', type: 'radio', tip: '' },
  { columnDef: 'riskMandatory', header: 'MANDATORY', cssSelector: 'riskMandatory', sort: false, key: 'isMandatory', type: 'radio', tip: '' },
  { columnDef: 'riskcreatedDate', header: 'CREATED', cssSelector: 'riskcreatedDate', sort: false, key: 'createdAt', type: 'date', tip: '' },
  { columnDef: 'riskUpdatedDate', header: 'UPDATED', cssSelector: 'riskUpdatedDate', sort: false, key: 'updatedAt', type: 'date', tip: '' },
  {
    columnDef: 'editDelete',
    header: 'ACTION',
    cssSelector: 'delete',
    sort: false,
    type: 'editDelete',
    key: '_id',
    tip: '',
  },
];

export const OnboardingQuestionTable = [
  { columnDef: 'questionnaireName', header: 'QUESTIONNAIRE', cssSelector: 'element-name', sort: false, key: 'templateName', type: 'text', tip: '' },
  { columnDef: 'validationProgress', header: 'VALIDATION PROGRESS', cssSelector: '', sort: false, key: 'progress', type: 'text', tip: '' },
  { columnDef: 'viewQuestionnaire', header: 'ACTION', cssSelector: 'view', sort: false, type: 'view', key: '_id', tip: 'View Questionnaire' },
];

export const allowedFileTypes = ['pdf', 'xlsx', 'jpg', 'jpeg', 'png', 'xls', 'csv', 'ppt', 'pptx'];

export const styleSections = [
  {
    fieldName: 'Page Title',
    fieldKey: 'pageTitle',
  },
  {
    fieldName: 'Section Title',
    fieldKey: 'sectionTitle',
  },
  {
    fieldName: 'Sub Section Title',
    fieldKey: 'subSectionTitle',
  },
  {
    fieldName: 'Content',
    fieldKey: 'contentStyle',
  },
];

export const Colors = [
  '#000000',
  '#e60000',
  '#ff9900',
  '#ffff00',
  '#008a00',
  '#0066cc',
  '#9933ff',
  '#ffffff',
  '#facccc',
  '#ffebcc',
  '#ffffcc',
  '#cce8cc',
  '#cce0f5',
  '#ebd6ff',
  '#bbbbbb',
  '#f06666',
  '#ffc266',
  '#ffff66',
  '#66b966',
  '#66a3e0',
  '#c285ff',
  '#888888',
  '#a10000',
  '#b26b00',
  '#b2b200',
  '#006100',
  '#0047b2',
  '#6b24b2',
  '#444444',
  '#5c0000',
  '#663d00',
  '#666600',
  '#003700',
  '#002966',
  '#3d1466',
];

export const FontSize = [
  {
    label: '10px',
    value: '10px',
  },
  {
    label: '12px',
    value: '12px',
  },
  {
    label: '14px',
    value: '14px',
  },
  {
    label: '16px',
    value: '16px',
  },
  {
    label: '18px',
    value: '18px',
  },
  {
    label: '20px',
    value: '20px',
  },
  {
    label: '22px',
    value: '22px',
  },
  {
    label: '24px',
    value: '24px',
  },
];

export const FontFamily = [
  {
    label: 'Roboto',
    value: 'Roboto',
  },
  {
    label: 'Montserrat',
    value: 'Montserrat',
  },
  {
    label: 'Lato',
    value: 'Lato',
  },
  {
    label: 'Noto Sans',
    value: 'NotoSans',
  },
  {
    label: 'Raleway',
    value: 'Raleway',
  },
  {
    label: 'Source Sans Pro',
    value: 'SourceSansPro',
  },
  {
    label: 'PT Sans',
    value: 'PTSans',
  },
  {
    label: 'Merriweather',
    value: 'Merriweather',
  },
  {
    label: 'Roboto Slab',
    value: 'RobotoSlab',
  },
  {
    label: 'Poppins',
    value: 'Poppins',
  },
  {
    label: 'Inter',
    value: 'Inter',
  },
];

export const Style = [
  {
    label: 'Bold',
    value: 'bold',
  },
  {
    label: 'Italic',
    value: 'italic',
  },
  {
    label: 'Underline',
    value: 'underline',
  },
];

export enum UPLOAD {
  FILE_FORMAT = 'Fileformat',
  FILE_LIMIT = 'FileLimits',
}

export enum DisplayEditableFields {
  HEADING = 'heading',
  BUSINESS_UNIT = 'business-units',
  FUNCTIONS = 'functions',
  COST_CENTERS = 'cost-centers',
  SUB_SECTION_HEADING = 'sub-section-heading',
}

export const ORG_ATTRIBUTE = {
  'business-units': 'businessUnit',
  functions: 'functions',
  'cost-centers': 'costCenters',
};

export const steps = [
  {
    step: '1',
    name: 'Demand',
  },
  {
    step: '2',
    name: 'RFP',
  },
  {
    step: '3',
    name: 'Sourcing & Invitation',
  },
  {
    step: '4',
    name: 'Q&A',
  },
  {
    step: '5',
    name: 'Selection',
  },
  {
    step: '6',
    name: 'SOW',
  },
  {
    step: '7',
    name: 'Project Management',
  },
  {
    step: '8',
    name: 'Performance',
  },
];

export const ClientOnboardingStatus = {
  pending: 'Pending',
  on_going: 'On Going',
  active: 'Active',
  off_boarding: 'Off Boarding',
  inactive: 'Inactive',
};

export const ConsourceStatus = {
  Pending: 'pending',
  Active: 'active',
  Inactive: 'inactive',
}

export const providerOnboardingStatus = {
  on_going: 'on Going',
  done: 'done',
  off_boarding: 'off Boarding',
}

export const OnboardingStatus =[
  {
    label: 'On Going',
    value: 'on_going',
  },
  {
    label: 'Done',
    value: 'done',
  },
  {
    label: 'Off Boarding',
    value: 'off_boarding',
  },
]

export const StatusTypeForProvider = {
  consource: 1,
  cgn: 2,
  onboarding: 3,
}

export const ClientOnboardingStatusArray = ['Pending', 'Active', 'On Going', 'Off Boarding', 'Inactive'];

export const StripeBaseUrl = 'https://dashboard.stripe.com/test';

const UserRoles = {
  'Client Admin': '1',
  'Procurement Manager': '2',
  'Project Manager': '3',
  'Project Sponsor': '4',
  'Provider Admin': '6',
  'Provider Parther': '7',
  'Provider User': '8',
  'Provider Management': '9',
};

const ClientAdminChangeRequestStatus = { Pending: 'initiated', Accepted: 'accepted', Rejected: 'rejected' };
const ClientAdminChangeRequestStatusColors = { initiated: 'tag-pending', accepted: 'tag-accepted', rejected: 'tag-rejected' };

export const AdminChangeRequestTable = [
  {
    columnDef: 'companyName',
    header: 'CLIENT NAME',
    cssSelector: 'element-name',
    sort: true,
    key: 'companyName',
    photoKey: 'companyPhoto',
    type: 'photoName',
    tip: '',
  },
  {
    columnDef: 'clientName',
    header: 'ADMIN NAME',
    cssSelector: 'element-name',
    sort: true,
    key: 'clientName',
    photoKey: 'clientPhoto',
    type: 'photoName',
    tip: '',
  },
  { columnDef: 'userName', header: 'USER NAME', cssSelector: 'element-name', sort: true, key: 'userName', photoKey: 'userPhoto', type: 'photoName', tip: '' },
  {
    columnDef: 'status',
    header: 'STATUS',
    cssSelector: 'status',
    sort: false,
    key: 'status',
    type: 'status',
    statusArray: ClientAdminChangeRequestStatus,
    statusClass: ClientAdminChangeRequestStatusColors,
    tip: '',
  },
  { columnDef: 'createdAt', header: 'REQUESTED ON', cssSelector: 'requested-on', sort: true, key: 'createdAt', type: 'date', tip: '' },
  {
    columnDef: 'acceptReject',
    header: 'ACTION',
    cssSelector: 'acceptReject',
    sort: false,
    type: 'acceptRejectAction',
    pendingStatusKey: 'initiated',
    key: '_id',
  },
];

export const ProviderAdminChangeRequestTable = [
  {
    columnDef: 'companyName',
    header: 'FIRM NAME',
    cssSelector: 'element-name',
    sort: true,
    key: 'firmName',
    photoKey: 'companyPhoto',
    type: 'photoName',
    tip: '',
  },
  {
    columnDef: 'clientName',
    header: 'ADMIN NAME',
    cssSelector: 'element-name',
    sort: true,
    key: 'adminName',
    photoKey: 'clientPhoto',
    type: 'photoName',
    tip: '',
  },
  { columnDef: 'userName', header: 'USER NAME', cssSelector: 'element-name', sort: true, key: 'userName', photoKey: 'userPhoto', type: 'photoName', tip: '' },
  {
    columnDef: 'status',
    header: 'STATUS',
    cssSelector: 'status',
    sort: false,
    key: 'status',
    type: 'status',
    statusArray: ClientAdminChangeRequestStatus,
    statusClass: ClientAdminChangeRequestStatusColors,
    tip: '',
  },
  { columnDef: 'createdAt', header: 'REQUESTED ON', cssSelector: 'requested-on', sort: true, key: 'createdAt', type: 'date', tip: '' },
  {
    columnDef: 'acceptReject',
    header: 'ACTION',
    cssSelector: 'acceptReject',
    sort: false,
    type: 'acceptRejectAction',
    pendingStatusKey: 'initiated',
    key: '_id',
  },
];

export enum AdminRoleChangeStatus {
  INITIATED = 'initiated',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
}

export const AdminChangeStatus = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'Pending',
    value: 'initiated',
  },
  {
    label: 'Accepted',
    value: 'accepted',
  },
  {
    label: 'Rejected',
    value: 'rejected',
  },
];

export enum AdminPageType {
  LANGUAGE = 'language',
  CURRENCY = 'currency',
  TAXONOMY = 'taxonomy',
  NDA = 'nda',
  MSA = 'msa',
  RFP = 'rfp',
  SOW = 'sow',
  UPLOADS = 'message-settings',
  QUESTIONNAIRE = 'legal-entity',
  RISK = 'risk',
  SRM = 'srm',
  COUNTRY = 'countries',
}

export const AdminSettingPageTitle = {
  [AdminPageType.LANGUAGE]: { title: 'LANGUAGES', subtitle: 'Manage global-level Language settings here.' },
  [AdminPageType.CURRENCY]: { title: 'CURRENCIES', subtitle: 'Manage global-level Currency settings here.' },
  [AdminPageType.TAXONOMY]: { title: 'TAXONOMY', subtitle: 'Manage global-level Taxonomy settings here.' },
  [AdminPageType.NDA]: { title: 'NDA', subtitle: 'Manage global-level Non Disclosure Agreement (NDA) settings here.' },
  [AdminPageType.MSA]: { title: 'MSA', subtitle: 'Manage global-level Master Service Agreement (MSA) settings here.' },
  [AdminPageType.RFP]: { title: 'RFP', subtitle: 'Manage global-level Request For Proposal (RFP) settings here.' },
  [AdminPageType.SOW]: { title: 'SOW', subtitle: 'Manage global-level Statement Of Work (SOW) settings here.' },
  [AdminPageType.UPLOADS]: { title: 'DOCUMENTS', subtitle: 'Manage global-level Document settings here.' },
  [AdminPageType.QUESTIONNAIRE]: { title: 'CGN QUESTIONNAIRES', subtitle: 'Manage global-level CGN Questionnaire settings here.' },
  [AdminPageType.RISK]: { title: 'RISKS', subtitle: 'Manage global-level Risk settings here' },
  [AdminPageType.SRM]: { title: 'SUPPLIER RELATIONSHIP MANAGEMENT', subtitle: 'Manage global-level Supplier Relationship Management (SRM) settings here.' },
  [AdminPageType.COUNTRY]: { title: 'TAXONOMY', subtitle: 'Manage global-level Taxonomy settings here.' },
};

export const AdminSettingsRouteRegex = /\/dashboard\/adminSettings\/([^?/]+)/;

export const DemographyType = {
  INDUSTRY: 'industries',
  CAPABILITY: 'capabilities',
};

export enum ClientPageType {
  COMPANY_DETAILS = 'client-settings',
  TAXONOMY = 'client-demographics',
  NDA = 'nda',
  MSA = 'msa',
  DEMAND = 'demand',
  RFP = 'rfp',
  SOW = 'sow',
  PERFORMANCE = 'performance',
  UPLOADS = 'system-settings',
  QUESTIONNAIRE = 'legal-entity',
  RISK = 'risk',
  CLEAR = 'clear-data',
}

export const ClientSettingPageTitle = {
  [ClientPageType.COMPANY_DETAILS]: { title: 'Company Details', subtitle: 'Manage your Company Details here' },
  [ClientPageType.TAXONOMY]: { title: 'Taxonomy', subtitle: 'Manage Taxonomy settings here' },
  [ClientPageType.NDA]: { title: 'NDA', subtitle: 'Manage Non Disclosure Agreement (NDA) settings here' },
  [ClientPageType.MSA]: { title: 'MSA', subtitle: 'Manage Master Service Agreement (MSA) settings here' },
  [ClientPageType.DEMAND]: { title: 'Demand', subtitle: 'Manage Demand settings here' },
  [ClientPageType.RFP]: { title: 'RFP', subtitle: 'Manage Request For Proposal (RFP) settings here' },
  [ClientPageType.SOW]: { title: 'SOW', subtitle: 'Manage Statement Of Work (SOW) settings here' },
  [ClientPageType.PERFORMANCE]: { title: 'Performance', subtitle: 'Manage performance settings here' },
  [ClientPageType.UPLOADS]: { title: 'System Settings', subtitle: 'Manage your Systems Settings here' },
  [ClientPageType.QUESTIONNAIRE]: { title: 'Questionnaires', subtitle: 'Manage Questionnaire settings here' },
  [ClientPageType.RISK]: { title: 'Risk', subtitle: 'Manage Risk settings here' },
  [ClientPageType.CLEAR]: {
    title: 'Clear Data',
    subtitle:
      'Clean up your environment by deleting sandbox and other testing data. Data in sandbox are created by the application for trying out features when you have signed up for ConSource',
  },
};

export const ProviderSettingsRouteRegex = /\/invitation-dashboard\/customization\/([^?/]+)/;

export enum ProviderPageType {
  PROVIDER_DETAILS = 'provider-details',
  UPLOADS = 'system-settings',
}

export const ProviderSettingPageTitle = {
  [ProviderPageType.PROVIDER_DETAILS]: { title: 'Provider Details', subtitle: 'Manage your Provider Details here' },
  [ProviderPageType.UPLOADS]: { title: 'System Settings', subtitle: 'Manage System settings here' },
};

export const ProviderSettingsModuleObject = [
  {
    name: 'Provider Details',
    path: '/invitation-dashboard/customization/provider-details',
  },
  {
    name: 'System Settings',
    path: '/invitation-dashboard/customization/system-settings',
  },
  {
    name: 'Customization',
    path: '/invitation-dashboard/customization',
  },
];

export const ClientSettingsRouteRegex = /\/dashboard\/otherSettings\/([^?/]+)/;

export const ClientSettingsModuleObject = [
  {
    name: 'User Invite Requests',
    path: '/dashboard/users/invite-requests',
  },
  {
    name: 'Users',
    path: '/dashboard/users',
  },
  {
    name: 'Customization',
    path: '/dashboard/otherSettings',
  },
];

export const ClientAdminSettingsModuleObject = [
  {
    name: 'User Invite Requests',
    path: '/dashboard/users/invite-requests',
  },
  {
    name: 'Users',
    path: '/dashboard/users',
  },
];

export const FirmSettingsModuleObject = [
  {
    name: 'User Invite Requests',
    path: '/invitation-dashboard/users/invite-requests',
  },
];

export const InvitationStatus = {
  status: 1,
  type: 'sendInvite',
};

export enum ProviderPageType {
  GENERAL_INFO = 'general-info',
  ABOUT = 'about',
  OFFICES = 'offices',
  PUBLICATIONS = 'publications',
  OFFERINGS = 'offerings',
  CASE_STUDY = 'case-studies',
  LEGAL_ENTITY = 'legal-entity',
  ACCOUNT = 'account',
  CONTRACTS = 'contracts',
}

export const ProviderPageTitle = {
  [ProviderPageType.GENERAL_INFO]: { title: 'General Info' },
  [ProviderPageType.ABOUT]: { title: 'About' },
  [ProviderPageType.OFFICES]: { title: 'Offices' },
  [ProviderPageType.PUBLICATIONS]: { title: 'Publications' },
  [ProviderPageType.OFFERINGS]: { title: 'Offerings' },
  [ProviderPageType.CASE_STUDY]: { title: 'Case Studies' },
  [ProviderPageType.LEGAL_ENTITY]: { title: 'Legal Entity' },
  [ProviderPageType.ACCOUNT]: { title: 'Account' },
  [ProviderPageType.CONTRACTS]: { title: 'Contracts' },
};

export const DEFAULT_PRECISION = 2;

export const ClientProviderPageRouteRegex = /\/dashboard\/consultingFirm\/viewProfile\/[^\/]+\/company-profile\/([^/?]+)/;
export const FirmProviderPageRouteRegex = /\/invitation-dashboard\/firm-profile\/[^\/]+\/company-profile\/([^/?]+)/;
export const AdminProviderPageRouteRegex = /\/dashboard\/consulting-firms\/viewProfile\/[^\/]+\/company-profile\/([^/?]+)/;

export enum EntityType {
  INFO = 'info',
  ONBOARDING = 'on-boarding',
  RISK = 'risk',
  QUESTION_SET = 'question-set',
}

export const EntityTitle = {
  [EntityType.INFO]: { title: 'Legal Entity Information' },
  [EntityType.ONBOARDING]: { title: 'Questionnaires' },
  [EntityType.QUESTION_SET]: { title: 'Questionnaires' },
  [EntityType.RISK]: { title: 'Risk' },
};

export const EntityRegex = /\/dashboard\/consultingFirm\/viewProfile\/[^\/]+\/company-profile\/([^/?]+)/;

export enum LEGAL_ENTITIES_TAB {
  ACCOUNT = 'ACCOUNT',
  BILLING = 'BILLING',
  CONTRACTS = 'CONTRACTS',
}

export enum EDIT_PROJECT_DRAWER_TYPE {
  EDIT_KEY_PROJECT_INFO,
  EDIT_TAXONOMY_INFO,
}

export enum SIGNING_PARTY {
  CLIENT = 1,
  FIRM = 2,
}

export const SignatureTabs = {
  SOW: 'SoW',
  NDA: 'NDA',
  MSA: 'MSA',
};

export enum ADD_PROVIDER_PANEL_FIELDS {
  PROVIDER,
  RELATIONSHIP_MANAGER,
  TIER,
  SEGEMNT,
}

export const CurrencyConversionApiUrl = 'open.er-api.com';

export enum CLIENT_MODULES {
  'HOME' = 'HOME',
  'DEMAND_MANAGEMENT' = 'DEMAND_MANAGEMENT',
  'PROJECTS' = 'PROJECTS',
  'CONTRACTS' = 'CONTRACTS',
  'PANEL_MANAGEMENT' = 'PANEL_MANAGEMENT',
  'KNOWLEDGE_CENTER' = 'KNOWLEDGE_CENTER',
  'CATEGORY_MANAGEMENT' = 'CATEGORY_MANAGEMENT',
  'TASKS' = 'TASKS',
  'ADMIN' = 'ADMIN',
  'SETTINGS' = 'SETTINGS',
  'INVITE_USER' = 'INVITE_USER',
  'HELP_CENTER' = 'HELP_CENTER',
  'LOG_OUT' = 'LOG_OUT',
  'PROVIDER_PROFILES' = 'PROVIDER_PROFILES',
  'ADD_TASK' = 'ADD_TASK',
  'MESSAGES' = 'MESSAGES',
  'NOTIFICATIONS' = 'NOTIFICATIONS',
  'STRATEGIC_PRIORITIES' = 'STRATEGIC_PRIORITIES',
  'APPROVAL_WORKFLOWS' = 'APPROVAL_WORKFLOWS',
  'DEMANDS' = 'DEMANDS',
  'PROJECT_LIST' = 'PROJECT_LIST',
  'PROJECT_ANALYTICS' = 'PROJECT_ANALYTICS',
  'CONTRACTS_LIST' = 'CONTRACTS_LIST',
  'INVOICES_AND_PAYMENTS' = 'INVOICES_AND_PAYMENTS',
  'PROVIDER_PANEL' = 'PROVIDER_PANEL',
  'LEGAL_ENTITIES' = 'LEGAL_ENTITIES',
  'PANEL_ANALYTICS' = 'PANEL_ANALYTICS',
  'PERFORMANCE_MANAGEMENT' = 'PERFORMANCE_MANAGEMENT',
  'C_G_N' = 'C_G_N',
  'SUGGESTED_PROVIDER' = 'SUGGESTED_PROVIDER',
  'RISK_MANAGEMENT' = 'RISK_MANAGEMENT',
  'LIBRARY' = 'LIBRARY',
  'SCS_ACADEMY' = 'SCS_ACADEMY',
  'COMMUNITY' = 'COMMUNITY',
  'COMPANY_ANALYTICS' = 'COMPANY_ANALYTICS',
  'OBJECTIVES' = 'OBJECTIVES',
  'PROCESS_ANALYTICS' = 'PROCESS_ANALYTICS',
  'CONSULTING_BUDGETS' = 'CONSULTING_BUDGETS',
  'TASK_ANALYTICS' = 'TASK_ANALYTICS',
  'ALL_TASK' = 'ALL_TASK',
  'MY_TASK' = 'MY_TASK',
  'USER_LIST' = 'USER_LIST',
  'USER_INVITE_REQUESTS' = 'USER_INVITE_REQUESTS',
  'ACCOUNT_BILLING' = 'ACCOUNT_BILLING',
  'ACTIVITY' = 'ACTIVITY',
  'CUSTOMISATION' = 'CUSTOMISATION',
  'PROVIDER_PROFILE_COMPANY_PROFILE' = 'PROVIDER_PROFILE_COMPANY_PROFILE',
  'PROVIDER_PROFILE_L_E' = 'PROVIDER_PROFILE_L_E',
  'PROVIDER_PROFILE_PARTNER' = 'PROVIDER_PROFILE_PARTNER',
  'PROVIDER_PROFILE_PROJECTS' = 'PROVIDER_PROFILE_PROJECTS',
  'PROVIDER_PROFILE_ANALYTICS' = 'PROVIDER_PROFILE_ANALYTICS',
  'PROVIDER_PROFILE_CONTRACTS' = 'PROVIDER_PROFILE_CONTRACTS',
  'PROVIDER_PROFILE_MEETINGS' = 'PROVIDER_PROFILE_MEETINGS',
  'PROVIDER_PROFILE_TASKS' = 'PROVIDER_PROFILE_TASKS',
  'PROVIDER_PROFILE_SETTINGS' = 'PROVIDER_PROFILE_SETTINGS',
  'NDA_WIZARD' = 'NDA_WIZARD',
  'MSA_WIZARD' = 'MSA_WIZARD',
}

export const ProviderProfilesTabCode = [
  'PROVIDER_PROFILE_COMPANY_PROFILE',
  'PROVIDER_PROFILE_L_E',
  'PROVIDER_PROFILE_PARTNER',
  'PROVIDER_PROFILE_PROJECTS',
  'PROVIDER_PROFILE_ANALYTICS',
  'PROVIDER_PROFILE_CONTRACTS',
  'PROVIDER_PROFILE_MEETINGS',
  'PROVIDER_PROFILE_TASKS',
  'PROVIDER_PROFILE_SETTINGS',
];

export const ProviderProfileTabs = {
  PROVIDER_PROFILE_COMPANY_PROFILE: {
    routeName: 'Company Profile',
    routeUrl: 'company-profile',
  },
  PROVIDER_PROFILE_L_E: {
    routeName: 'Legal Entities',
    routeUrl: 'legal-entities',
  },
  PROVIDER_PROFILE_PARTNER: {
    routeName: 'Partners',
    routeUrl: 'contacts',
  },
  PROVIDER_PROFILE_PROJECTS: {
    routeName: 'Projects',
    routeUrl: 'projects',
  },
  PROVIDER_PROFILE_ANALYTICS: {
    routeName: 'Analytics',
    routeUrl: 'analytics',
  },
  PROVIDER_PROFILE_CONTRACTS: {
    routeName: 'Contracts',
    routeUrl: 'administrative',
  },
  PROVIDER_PROFILE_MEETINGS: {
    routeName: 'Meetings',
    routeUrl: 'meetings',
  },
  PROVIDER_PROFILE_TASKS: {
    routeName: 'Tasks',
    routeUrl: 'tasks',
  },
  PROVIDER_PROFILE_SETTINGS: {
    routeName: 'Settings',
    routeUrl: 'settings',
  },
};

export enum PROVIDER_MODULES {
  'HOME' = 'HOME',
  'PROVIDER_PROFILE' = 'PROVIDER_PROFILE',
  'LEGAL_ENTITIES' = 'LEGAL_ENTITIES',
  'LEGAL_ENTITIES_ACCOUNT' = 'LEGAL_ENTITIES_ACCOUNT',
  'LEGAL_ENTITIES_BILLING' = 'LEGAL_ENTITIES_BILLING',
  'LEGAL_ENTITIES_CONTRACTS' = 'LEGAL_ENTITIES_CONTRACTS',
  'LEGAL_ENTITIES_INVOICES' = 'LEGAL_ENTITIES_INVOICES',
  'LEGAL_ENTITIES_CLIENTS_ONBOARDING' = 'LEGAL_ENTITIES_CLIENTS_ONBOARDING',
  'USERS' = 'USERS',
  'CLIENTS' = 'CLIENTS',
  'CONTRACTS' = 'CONTRACTS',
  'CONTRACTS_LIST' = 'CONTRACTS_LIST',
  'INVOICES_AND_PAYMENTS' = 'INVOICES_AND_PAYMENTS',
  'PROJECTS' = 'PROJECTS',
  'OPPORTUNITIES' = 'OPPORTUNITIES',
  'ACCOUNTS_BILLING' = 'ACCOUNTS_BILLING',
  'TASKS' = 'TASKS',
  'TASK_ANALYTICS' = 'TASK_ANALYTICS',
  'ALL_TASK' = 'ALL_TASK',
  'MY_TASK' = 'MY_TASK',
  'ADMIN' = 'ADMIN',
  'USER_INVITE_REQUESTS' = 'USER_INVITE_REQUESTS',
  'CUSTOMISATION' = 'CUSTOMISATION',
  'INVITE_USER' = 'INVITE_USER',
  'HELP_CENTER' = 'HELP_CENTER',
  'LOG_OUT' = 'LOG_OUT',
  'ADD_TASK' = 'ADD_TASK',
  'MESSAGES' = 'MESSAGES',
  'NOTIFICATIONS' = 'NOTIFICATIONS',
}

export const ClientRoutes = {
  HOME: '/dashboard',
  // DEMAND_MANAGEMENT,
  STRATEGIC_PRIORITIES: '/dashboard/demand-management/strategic-priorities',
  APPROVAL_WORKFLOWS: '/dashboard/demand-management/approval-workflows',
  DEMANDS: '/dashboard/projects/demands',

  // PROJECTScompRoutes
  PROJECT_LIST: '/dashboard/projects',
  PROJECT_ANALYTICS: '/dashboard/projects/project-analytics',

  // CONTRACTS
  CONTRACTS_LIST: '/dashboard/administrative',
  INVOICES_AND_PAYMENTS: '/dashboard/administrative/invoices-and-payments',

  // PANEL_MANAGEMENT
  PROVIDER_PANEL: '/dashboard/consultingFirm',
  LEGAL_ENTITIES: '/dashboard/panel-management/on-boarding',
  PANEL_ANALYTICS: '/dashboard/panel-management/panel-analytics',
  PERFORMANCE_MANAGEMENT: '/dashboard/panel-management/performance-management',
  C_G_N: '/dashboard/panel-management/consource-global-network',
  SUGGESTED_PROVIDER: '/dashboard/panel-management/suggested-firm',
  RISK_MANAGEMENT: '/dashboard/panel-management/risk-management',

  // KNOWLEDGE_CENTER
  LIBRARY: '/dashboard/knowledge-center/library',
  SCS_ACADEMY: '/dashboard/knowledge-center/scs-academy',
  COMMUNITY: '/dashboard/knowledge-center/community',

  // CATEGORY_MANAGEMENT
  COMPANY_ANALYTICS: '/dashboard/category-management/company-analytics',
  OBJECTIVES: '/dashboard/category-management/objectives',
  PROCESS_ANALYTICS: '/dashboard/category-management/process-analytics',
  CONSULTING_BUDGETS: '/dashboard/category-management/consulting-budgets',

  // TASKS,
  TASK_ANALYTICS: '/dashboard/tasks/analytics',
  ALL_TASK: '/dashboard/tasks/all-tasks',
  MY_TASK: '/dashboard/tasks/my-tasks',

  // ADMIN: '',
  USER_LIST: '/dashboard/users',
  USER_INVITE_REQUESTS: '/dashboard/users/invite-requests',
  ACCOUNT_BILLING: '/dashboard/account-info/accounts-billing',
  ACTIVITY: '/dashboard/account-info/activity',

  // SETTINGS: '',
  CUSTOMISATION: '/dashboard/otherSettings/client-settings',
  CUSTOMISATION_TAXONOMY: '/dashboard/otherSettings/client-demographics/demographics',
  CUSTOMISATION_MSA_LAYOUT: '/dashboard/otherSettings/msa?libraryType=Layout',
  CUSTOMIZATION_MSA_TEMPLATE: '/dashboard/otherSettings/msa?libraryType=Template',
  CUSTOMISATION_NDA_TEMPLATE: '/dashboard/otherSettings/nda?libraryType=Template',
  CUSTOMISATION_NDA: '/dashboard/otherSettings/nda',
  CUSTOMISATION_NDA_LAYOUT: '/dashboard/otherSettings/nda?libraryType=Layout',
  CUSTOMISATION_DEMAND: '/dashboard/otherSettings/demand/template/add',
  CUSTOMISATION_DEMAND_TAXONOMY: '/dashboard/otherSettings/demand/taxonomy',
  CUSTOMISATION_RFP_SETTINGS: '/dashboard/otherSettings/rfp?tab=settings',
  CUSTOMISATION_RFP_LAYOUT: '/dashboard/otherSettings/rfp?libraryType=Layout',
  CUSTOMISATION_RFP_TEMPLATE: '/dashboard/otherSettings/rfp?libraryType=Template',
  CUSTOMISATION_SOW_LAYOUT: '/dashboard/otherSettings/sow?libraryType=Layout',
  CUSTOMISATION_SOW_TEMPALTE: '/dashboard/otherSettings/sow?libraryType=Template',
  CUSTOMISATION_PERFORMANCE: '/dashboard/otherSettings/performance/survey',
  CUSTOMISATION_PERFORMANCE_IMPACT: '/dashboard/otherSettings/performance/impact',
  CUSTOMISATION_SYSTEM_SETTINGS: '/dashboard/otherSettings/system-settings/file-upload',
  CUSTOMISATION_QUESTIONNAIRES: '/dashboard/otherSettings/legal-entity/template',
  CUSTOMISATION_RISK: '/dashboard/otherSettings/risk',
  CUSTOMISATION_CLEAR_DATA: '/dashboard/otherSettings/clear-data',

  // BottomMenu
  INVITE_USER: () => {},
  HELP_CENTER: () => {},
  LOG_OUT: () => {},

  // Other
  PROVIDER_PROFILES: '',
  PROVIDER_PROFILE_COMPANY_PROFILE: '',
  PROVIDER_PROFILE_L_E: '',
  PROVIDER_PROFILE_PARTNER: '',
  PROVIDER_PROFILE_PROJECTS: '',
  PROVIDER_PROFILE_ANALYTICS: '',
  PROVIDER_PROFILE_CONTRACTS: '',
  PROVIDER_PROFILE_MEETINGS: '',
  PROVIDER_PROFILE_TASKS: '',
  PROVIDER_PROFILE_SETTINGS: '',
  ADD_TASK: '',
  MESSAGES: '',
  NOTIFICATIONS: '',
};

export const ProviderRoute = {
  HOME: '/invitation-dashboard',
  PROVIDER_PROFILE: '/invitation-dashboard/firm-profile',
  LEGAL_ENTITIES: '/invitation-dashboard/legal-entity',
  USERS: '/invitation-dashboard/users',
  CLIENTS: '/invitation-dashboard/clients',

  // CONTRACTS
  CONTRACTS_LIST: '/invitation-dashboard/administrative/list',
  INVOICES_AND_PAYMENTS: '/invitation-dashboard/administrative/invoices-and-payments',

  PROJECTS: '/invitation-dashboard/projects',
  OPPORTUNITIES: '/invitation-dashboard/opportunities',
  ACCOUNTS_BILLING: '/invitation-dashboard/account-info/accounts-billing',

  // TASKS
  TASK_ANALYTICS: '/invitation-dashboard/analytics',
  ALL_TASK: '/invitation-dashboard/all-tasks',
  MY_TASK: '/invitation-dashboard/my-tasks',

  // ADMIN: '',
  USER_INVITE_REQUESTS: '/invitation-dashboard/users/invite-requests',
  CUSTOMISATION: '/invitation-dashboard/customization/provider-details',

  // BottomMenu
  INVITE_USER: () => {},
  HELP_CENTER: () => {},
  LOG_OUT: () => {},

  // other
  ADD_TASK: '',
  MESSAGES: '',
  NOTIFICATIONS: '',
  LEGAL_ENTITIES_ACCOUNT: '',
  LEGAL_ENTITIES_BILLING: '',
  LEGAL_ENTITIES_CONTRACTS: '',
  LEGAL_ENTITIES_INVOICES: '',
  LEGAL_ENTITIES_CLIENTS_ONBOARDING: '',
};

export enum COMPANY_PROFILE_TAB  {
  COMPANY_INFO = 'COMPANY_INFO',
  COMPANY_SETTINGS = 'COMPANY_SETTINGS'
}